"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CustomerInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// All enterprise related data
var CustomerInfo = (_CustomerInfo = {
  // General -----------------------------------------------------------------------------------------
  welcome: {
    nl: "Welkom",
    fr: "Bienvenue",
    en: "Welcome",
    de: "Willkommen"
  },
  search_and_select: {
    nl: "Zoek en selecteer jouw vestiging",
    fr: "Cherchez et sélectionnez votre établissement",
    en: "Search and select your establishment",
    de: "Suchen und wählen Sie Ihre Niederlassung"
  },
  dear: {
    nl: "Beste",
    fr: "Bonjour",
    en: "Dear",
    de: "Sehr geehrte"
  },
  ci_yes: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes",
    de: "Ja"
  },
  ci_no: {
    nl: "Nee",
    fr: "Non",
    en: "No",
    de: "Nein"
  },
  next: {
    nl: "Volgende",
    fr: "Suivant",
    en: "Next",
    de: "Weiter"
  },
  previous: {
    nl: "Vorige",
    fr: "Précédent",
    en: "Previous",
    de: "Zurück"
  },
  ci_close: {
    nl: "Afsluiten",
    fr: "Fermer",
    en: "Close",
    de: "Schließen"
  },
  ready_to_collaborate: {
    nl: "Klaar om samen te werken aan jouw",
    fr: "Vous êtes prêt à colaborer ensemble à votre",
    en: "Ready to collaborate on your",
    de: "Bereit, mit Ihnen zusammenzuarbeiten"
  },
  local_online_visibility: {
    nl: "lokale online visibiliteit?",
    fr: "visibilité locale en ligne ?",
    en: "local online visibility?",
    de: "lokale Online-Sichtbarkeit?"
  },
  // Login -----------------------------------------------------------------------------------------
  together_we_work: {
    nl: 'Samen werken we aan een “STERK” verhaal ',
    fr: 'Ensemble, nous travaillons sur une histoire "FORTE"',
    en: 'Together we work on a "STRONG" story ',
    de: 'Gemeinsam arbeiten wir an einer "STARKEN" Geschichte'
  },
  discover_the_added_value: {
    nl: "Ontdek de meerwaarde voor jouw onderneming op:",
    fr: "Découvrez la valeur ajoutée pour votre entreprise sur :",
    en: "Discover the added value for your business at:",
    de: "Entdecken Sie die zusätzliche Wertschätzung für Ihr Unternehmen auf:"
  },
  visit_our_site: {
    nl: "Bezoek website",
    fr: "Visitez notre site",
    en: "Visit our site",
    de: "Besuchen Sie unsere Website"
  },
  discover_more: {
    nl: "Ontdek meer",
    fr: "Découvrir plus",
    en: "Discover more ",
    de: "Mehr erfahren"
  },
  ci_address: {
    nl: "Adres",
    fr: "Adresse",
    en: "Address",
    de: "Adresse"
  },
  is_required_by_law: {
    nl: "(is wettelijk verplicht)",
    fr: "(requise par la loi)",
    en: "(is required by law)",
    de: "(ist nach gesetzlichen Vorschriften erforderlich)"
  },
  tel_mob: {
    nl: "Telefoon of mobiel",
    fr: "Téléphone ou mobile",
    en: "Telephone or mobile",
    de: "Telefon oder Mobiltelefon"
  },
  number_required_by_law: {
    nl: "(1 nr. is wettelijk verplicht)",
    fr: "(1 est requis par la loi)",
    en: "(1 is required by law) ",
    de: "(1 ist nach gesetzlichen Vorschriften erforderlich)"
  },
  not_Required: {
    nl: "(niet verplicht)",
    fr: "(non requis)",
    en: "(not required)",
    de: "(nicht erforderlich)"
  },
  ci_email_login: {
    nl: "E-mail adres",
    fr: "Adresse e-mail",
    en: "E-mail address",
    de: "E-Mail-Adresse"
  },
  legally_required: {
    nl: "(is wettelijk verplicht)",
    fr: "(légalement obligatoire)",
    en: "(legally required)"
  },
  ci_main_activity: {
    nl: "Je hoofdactiviteit",
    fr: "Votre activité principale",
    en: "Your main activity",
    de: "Ihre Hauptaktivität"
  },
  in_cbe: {
    nl: "(in KBO):",
    fr: "(en BCE) :",
    en: "(in CBE):",
    de: "(in CBE):"
  },
  ci_customized_activity: {
    nl: "Je aangepaste activiteit via onze diensten",
    fr: "Votre activité sur mesure grâce à nos services",
    en: "Your customized activity through our services",
    de: "Ihre individuelle Aktivität durch unsere Dienste"
  },
  sign_up_and_fill_in: {
    nl: "Meld je aan en vul eventuele extra nuttige info aan zodat jouw doelgroep je nog beter kan vinden! Je verdient hiermee € 100!",
    fr: "Inscrivez-vous et remplissez toute information supplémentaire utile pour que votre groupe cible puisse encore mieux vous trouver ! Vous gagnez 100 € avec ça !",
    en: "Sign up and fill in any additional useful information so that your target group can find you even better! You earn € 100 with this!",
    de: "Melden Sie sich an und füllen Sie alle zusätzlichen nützlichen Informationen ein, damit Ihr Zielgruppe Ihnen noch besser finden kann! Sie verdienen € 100 mit diesem!"
  },
  here_you_can_log_in_with: {
    nl: "Hier kan je aanmelden met jouw persoonlijk aangemaakt account.",
    fr: "Ici, vous pouvez vous connecter avec votre compte personnel.",
    en: "Here you can log in with your personally created account.",
    de: "Hier können Sie sich mit Ihrem persönlichen erstellten Konto anmelden."
  },
  register_with_personal_otp: {
    nl: "Registreer hier met jouw persoonlijk OTP",
    fr: "Enregistrez-vous ici avec votre OTP personnel",
    en: "Register here with your personal OTP",
    de: "Hier registrieren Sie sich mit Ihrem persönlichen OTP"
  },
  your_enterprise_number: {
    nl: "Jouw ondernemingsnummer",
    fr: "Votre numéro d'entreprise",
    en: "Your enterprise number",
    de: "Ihre Unternehmensnummer"
  },
  your_establishment_number: {
    nl: "Jouw vestigingsnummer",
    fr: "Votre numéro d'etablissement",
    en: "Your establishment number",
    de: "Ihre Betriebsnummer"
  },
  otp: {
    nl: "One Time Password",
    fr: "Mot de passe à usage unique",
    en: "One Time Password",
    de: "Einmal-Passwort"
  },
  dont_have_otp_yet: {
    nl: "Ik heb nog geen OTP",
    fr: "Je n'ai pas encore d'OTP ",
    en: "I don't have an OTP yet",
    de: "Ich habe noch kein OTP"
  },
  password: {
    nl: "Wachtwoord",
    fr: "Mot de passe",
    en: "Password",
    de: "Passwort"
  },
  forgot_password: {
    nl: "Wachtwoord vergeten?",
    fr: "Mot de passe oublié ?",
    en: "Forgot password?",
    de: "Passwort vergessen?"
  },
  reset_password: {
    nl: "Wachtwoord resetten",
    fr: "Reset mot de passe",
    en: "Reset password",
    de: "Passwort zurücksetzen"
  },
  ok_ready: {
    nl: "OK, IK BEN KLAAR",
    fr: "OK, JE SUIS PRÊT ",
    en: "OK, I'M READY ",
    de: "OK, ICH BIN BEREIT"
  },
  i_already_have_account: {
    nl: "Ik heb al een account",
    fr: "J'ai déjà un compte",
    en: "I already have an account",
    de: "Ich habe bereits ein Konto"
  },
  i_dont_have_account: {
    nl: "Ik heb nog geen account",
    fr: "Je n'ai pas de compte",
    en: "I don't have an account",
    de: "Ich habe noch kein Konto"
  },
  ci_create_an_account: {
    nl: "Maak een account aan",
    fr: "Créer un compte",
    en: "Create an account",
    de: "Konto erstellen"
  },
  ci_create_account: {
    nl: "Account aanmaken",
    fr: "Créer un compte",
    en: "Create account",
    de: "Konto erstellen"
  },
  // 01 Welcome -----------------------------------------------------------------------------------------
  welcome_to_local: {
    nl: "Welkom bij 100% Lokaal",
    fr: "100% Local, soyez les bienvenus",
    en: "Welcome to 100% Local",
    de: "Willkommen zu 100% Local"
  },
  thank_you_for_participating: {
    nl: "Dank je... om mee te werken aan het beheren en optimaliseren van de gegevens van jouw onderneming!",
    fr: "Merci... de participer à la gestion et à l'optimisation des données de votre entreprise !",
    en: "Thank you... for participating in managing and optimizing your company's data !",
    de: "Vielen Dank... für die Teilnahme am Verwalten und Optimieren Ihrer Unternehmensdaten!"
  },
  we_help_as_much: {
    nl: "Wij helpen je zoveel mogelijk!",
    fr: "Nous vous aidons au maximum !",
    en: "We help you as much as possible!",
    de: "Wir helfen Ihnen so viel wie möglich!"
  },
  this_additional_info: {
    nl: "Deze bijkomende informatie zal nuttig zijn voor elke bezoeker die jouw onderneming heeft gevonden.",
    fr: "Ces informations supplémentaires seront utiles à tout visiteur ayant trouvé votre entreprise.",
    en: "This additional information will be useful to any visitor who has found your business.",
    de: "Diese zusätzlichen Informationen werden für jeden Besucher nützlich, der Ihr Unternehmen gefunden hat."
  },
  my_company_active: {
    nl: "MIJN ONDERNEMING IS ACTIEF?",
    fr: "MON ENTREPRISE EST ACTIVE ?",
    en: "MY COMPANY IS ACTIVE?",
    de: "IHR UNTERNEHMEN IST AKTIV?"
  },
  now_we_can_continue: {
    nl: "Nu kunnen we verder!",
    fr: "Maintenant, nous pouvons continuer !",
    en: "Now we can continue!",
    de: "Jetzt können wir fortfahren!"
  },
  your_company_deactivated: {
    nl: "Jouw onderneming wordt gedeactiveerd :)",
    fr: "Votre entreprise sera désactivée :)",
    en: "Your company will be deactivated :)",
    de: "Ihr Unternehmen wird deaktiviert :)"
  },
  i_accept_GDPR: {
    nl: "Ik aanvaard de verwerking van mijn gegevens volgens de GDPR/AVG.",
    fr: "J'accepte le traitement de mes données conformément au RGPD.",
    en: "I accept the processing of my data according to the GDPR.",
    de: "Ich akzeptiere die Verarbeitung meiner Daten gemäß der GDPR."
  },
  last_accepted_on: {
    nl: "Laatst aanvaard op",
    fr: "Dernière acceptation le",
    en: "Last accepted on",
    de: "Zuletzt akzeptiert am"
  },
  i_accept_the: {
    nl: "Ik aanvaard de",
    fr: "J'accepte les",
    en: "I accept the",
    de: "Ich akzeptiere die"
  },
  general_terms_and_conditions: {
    nl: "algemene voorwaarden",
    fr: "conditions générales",
    en: "general terms and conditions",
    de: "allgemeine Bedingungen"
  },
  i_accept_my_municipality: {
    nl: "Ik aanvaard dat mijn gegevens - in combinatie met 100procentlokaal - gedeeld worden met mijn stad of gemeente.",
    fr: "J'accepte que mes données - combinées avec 100pourcentlocal - soient partagées avec ma ville ou ma commune.",
    en: "I accept that my data - combined with 100percentlocal - will be shared with my city or municipality.",
    de: "Ich akzeptiere, dass meine Daten - in Verbindung mit 100percentlocal - mit meiner Stadt oder Gemeinde geteilt werden."
  },
  city_support_good_idea: {
    nl: "Vind je de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee?",
    fr: "Pensez-vous que le soutien de votre ville ou municipalité à cette initiative est une bonne idée ?",
    en: "Do you think your city or municipality's support for this initiative is a good idea?",
    de: "Halten Sie die Unterstützung Ihrer Stadt oder Gemeinde für diese Initiative für eine gute Idee?"
  },
  would_you_find_city_support_good_idea: {
    nl: "Zou jij de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee vinden?",
    fr: "Considéreriez-vous que soutenir cette initiative par votre ville ou municipalité serait une bonne idée ?",
    en: "Would you consider supporting this initiative by your city or municipality a good idea?",
    de: "Fänden Sie die Unterstützung Ihrer Stadt oder Gemeinde für diese Initiative eine gute Idee?"
  },
  please_choose_an_option: {
    nl: "Gelieve een optie te kiezen!",
    fr: "Veuillez choisir une option !",
    en: "Please choose an option!",
    de: "Bitte wählen Sie eine Option!"
  },
  yes_i_appreciate_support_city: {
    nl: "Ja! Ik waardeer de ondersteuning van dit initiatief door mijn stad of gemeente",
    fr: "Oui! J'apprécie le soutien de ma ville ou municipalité pour cette initiative",
    en: "Yes! I appreciate the support of my city or municipality for this initiative",
    de: "Ja! Ich bedanke mich für die Unterstützung Ihrer Stadt oder Gemeinde für diese Initiative"
  },
  yes_i_would_appreciate_support_city: {
    nl: "Ja! Ik zou de ondersteuning van dit initiatief door mijn stad of gemeente een schitterend idee vinden!",
    fr: "Oui ! J'aimerais le soutien de ma ville ou municipalité pour cette initiative!",
    en: "Yes! I would love the support of my city or municipality for this initiative!",
    de: "Ja! Ich würde gerne die Unterstützung Ihrer Stadt oder Gemeinde für diese Initiative!"
  },
  no_opinion_about_project: {
    nl: "Ik heb geen mening over dit project",
    fr: "Je n'ai pas d'avis sur ce projet",
    en: "I have no opinion about this project",
    de: "Ich habe keine Meinung über dieses Projekt"
  },
  contest: {
    nl: "WEDSTRIJD!",
    fr: "CONCOURS !",
    en: "CONTEST!",
    de: "ENTSCHEIDUNG!"
  },
  you_are_participating_too_right: {
    nl: "Jij doet toch ook mee?",
    fr: "Participez-vous aussi ?",
    en: "You're participating too, right?",
    de: "Sie teilnehmen auch, richtig?"
  },
  fantastic: {
    nl: "Fantastisch!",
    fr: "Fantastique !",
    en: "Fantastic!",
    de: "Fantastisch!"
  },
  you_do_not_know_what_missing: {
    nl: "Je weet niet wat je mist :)",
    fr: "Vous ne savez pas ce que vous manquez :)",
    en: "You do not know what you are missing :)",
    de: "Sie wissen nicht, was Sie fehlen :)"
  },
  for_the: {
    nl: "Voor de",
    fr: "Pour la",
    en: "For the",
    de: "Für die"
  },
  businesspage_100procentlocal: {
    nl: "Business Page in 100%Lokaal",
    fr: "Page Entreprise en 100% Local",
    en: "Business Page in 100%Local",
    de: "Business Page in 100%Local"
  },
  businesspage_100procentlocal_part_2: {
    nl: "betaalt de ondernemer € 100/jaar. Dit is het éénmalig voordeel dat je verkrijgt wanneer je alle gegevens voor jouw onderneming aanvult!",
    fr: "l'entrepreneur paie 100 €/an. C'est l'avantage unique que vous recevez lorsque vous remplissez toutes les données pour votre entreprise !",
    en: "the entrepreneur pays € 100/year. This is the one-time benefit that you receive when you complete all the data for your company!",
    de: "der Eintrager zahlt € 100/Jahr. Dies ist der einmalige Vorteil, den Sie erhalten, wenn Sie alle Daten für Ihr Unternehmen ausfüllen!"
  },
  businesspage_100procentlocal_part_3: {
    nl: "Bovendien doet iedere ondernemer die deelneemt ook automatisch mee met de grote wedstrijd. Elke 100ste ondernemer wint een jaarabonnement voor een compleet dienstenpakket ter waarde van € 1600.",
    fr: "De plus, chaque entrepreneur qui participe participe automatiquement au grand concours. Chaque 100e entrepreneur gagne un abonnement annuel pour un ensemble complet de services d'une valeur de 1600 €.",
    en: "In addition, every entrepreneur who participates automatically participates in the big competition. Every 100th entrepreneur wins an annual subscription for a complete service package worth € 1600.",
    de: "Darüber hinaus teilen alle Eintrittsberechtigten automatisch in die große Wettbewerbskampagne teil. Jeder 100. Eintrager erhält ein jährliches Abonnement für ein vollständiges Servicepaket mit einem Wert von € 1600."
  },
  attention: {
    nl: "OPGELET!",
    fr: "ATTENTION !",
    en: "ATTENTION!",
    de: "ACHTUNG!"
  },
  businesspage_100procentlocal_part_4: {
    nl: "Het aanleveren van het logo (.ai, .eps, .svg, .pdf-vector) maakt deel uit van het wedstrijdreglement voor deelname.",
    fr: "La fourniture du logo (.ai, .eps, .svg, .pdf vector) fait partie du règlement du concours pour la participation.",
    en: "Supplying the logo (.ai, .eps, .svg, .pdf vector) is part of the competition rules for entry.",
    de: "Das Liefern des Logos (.ai, .eps, .svg, .pdf-Vektor) ist Teil des Wettbewerbsreglements für Eintritt."
  },
  contest_rules: {
    nl: "Lees of haal hier het wedstrijdreglement op.",
    fr: "Lire ou télécharger le règlement du concours ici.",
    en: "Read or download the competition rules here.",
    de: "Lesen Sie oder laden Sie hier das Wettbewerbsreglement herunter."
  },
  // 02 Personal -----------------------------------------------------------------------------------------
  start_personal_info: {
    nl: "Laten we starten met je persoonlijke gegevens",
    fr: "Commençons par vos informations personnelles",
    en: "Let's start with your personal information",
    de: "Lassen Sie uns mit Ihren persönlichen Daten starten"
  },
  the_information_below: {
    nl: "Onderstaande gegevens worden",
    fr: "Les informations ci-dessous ne sont",
    en: "The information below is",
    de: "Die untenstehenden Informationen sind"
  },
  never: {
    nl: "NOOIT",
    fr: "JAMAIS",
    en: "NEVER",
    de: "NIEMALS"
  },
  the_information_below_part2: {
    nl: "online gepubliceerd maar ook niet gedeeld met uw lokaal bestuur.",
    fr: "publiées en ligne ni partagées avec votre gouvernement local.",
    en: "published online nor shared with your local government.",
    de: "online veröffentlicht, aber nicht mit Ihrem lokalen Regierungsbezirk geteilt."
  },
  the_information_below_part3: {
    nl: "Deze zijn uitsluitend voor intern gebruik om je te contacteren wanneer er toch iets niet correct is ingevuld.",
    fr: "Ceux-ci sont à usage interne uniquement pour vous contacter si quelque chose n'est pas rempli correctement.",
    en: "These are for internal use only to contact you if something is not filled in correctly.",
    de: "Die sind nur für interne Verwendung, um Sie zu kontaktieren, wenn etwas nicht korrekt ausgefüllt ist."
  },
  ci_prename: {
    nl: "Voornaam",
    fr: "Prénom",
    en: "First name",
    de: "Vorname"
  },
  ci_lastname: {
    nl: "Achternaam",
    fr: "Nom",
    en: "Last name",
    de: "Nachname"
  },
  ci_name: {
    nl: "Naam",
    fr: "Nom",
    en: "Name",
    de: "Name"
  },
  ci_mobile: {
    nl: "Mobiele telefoon",
    fr: "Téléphone mobile",
    en: "Mobile phone",
    de: "Mobiltelefon"
  },
  ci_phone: {
    nl: "Telefoon",
    fr: "Téléphone",
    en: "Phone",
    de: "Telefon"
  },
  ci_mail: {
    nl: "Email",
    fr: "E-mail",
    en: "E-mail",
    de: "E-Mail"
  },
  ci_fax: {
    nl: "Fax",
    fr: "Télécopieur",
    en: "Fax",
    de: "Fax"
  },
  // 03 Search -----------------------------------------------------------------------------------------
  how_can_visitors_reacth_you: {
    nl: "Hoe kunnen bezoekers je bereiken?",
    fr: "Les visiteurs, comment peuvent-ils vous joindre ?",
    en: "How can visitors reach you?",
    de: "Wie können Besucher Sie erreichen?"
  },
  you_understand_importance: {
    nl: "Je begrijpt dat het heel belangrijk is om correcte gegevens van je onderneming te publiceren.",
    fr: "Vous comprenez qu'il est très important de publier des données correctes sur votre entreprise.",
    en: "You understand that it is very important to publish correct data about your company.",
    de: "Sie verstehen, dass es sehr wichtig ist, die korrekten Daten über Ihr Unternehmen zu veröffentlichen."
  },
  visitors_reacht_you: {
    nl: "Op deze manier kunnen bezoekers je ook bereiken.",
    fr: "Ainsi, les visiteurs peuvent également vous joindre.",
    en: "This way visitors can also reach you.",
    de: "Auf diese Weise können Besucher Sie auch erreichen."
  },
  the_following_information: {
    nl: "De volgende informatie zal",
    fr: "Les informations suivantes",
    en: "The following information",
    de: "Die folgenden Informationen"
  },
  visible_to_everyone: {
    nl: "ZICHTBAAR ZIJN VOOR IEDEREEN!",
    fr: "SERONT VISIBLES PAR TOUS !",
    en: "WILL BE VISIBLE TO EVERYONE!",
    de: "WIRD FÜR JEDERMAN SICHTBARER SEIN!"
  },
  corporate_name: {
    nl: "Maatschappelijke Naam (kan niet gewijzigd worden)",
    fr: "Nom de l'entreprise (ne peut pas être modifié)",
    en: "Corporate name (cannot be changed)",
    de: "Unternehmensname (kann nicht geändert werden)"
  },
  commercial_name: {
    nl: "Commerciële naam",
    fr: "Nom commercial",
    en: "Commercial name",
    de: "Kommerzieller Name"
  },
  commercial_name_info: {
    nl: 'Indien uw "Commerciële naam" verschilt van uw "Officiële naam (ook Maatschappelijke naam genoemd)" kan je deze hier invoeren. Wij respecteren alle leestekens zoals je deze hier zelf invoert. Gebruik dus HOOFDLETTERS en kleine letters waar nodig!',
    fr: 'Si votre "Nom commercial" est différent de votre "Nom officiel (également appelé Raison sociale)", vous pouvez le saisir ici. Nous respectons tous les signes de ponctuation lorsque vous les saisissez ici vous-même. Utilisez donc des majuscules et des minuscules si nécessaire !',
    en: 'If your "Commercial name" is different from your "Official name (also called Corporate name)" you can enter it here. We respect all punctuation marks as you enter them here yourself. So use UPPER and lowercase where necessary!',
    de: 'Wenn Ihr "Kommerzieller Name" anders als Ihr "Amtsname (auch als Unternehmensname genannt)" ist, können Sie ihn hier eingeben. Wir respektieren alle Interpunktionen, wie Sie sie hier selbst eingeben. Verwenden Sie daher GROß- und kleingeschrieben, wenn nötig!'
  },
  email_never_visible: {
    nl: "Email (wordt dus nooit zichtbaar)",
    fr: "E-mail (ne sera donc jamais visible)",
    en: "E-mail (thus never becomes visible)",
    de: "E-Mail-Adresse (wird niemals angezeigt)"
  },
  publication_of_one_telephone: {
    nl: "De publicatie van 1 telefoonnummer is een",
    fr: "La publication d'1 numéro de téléphone est une",
    en: "The publication of 1 telephone number is a",
    de: "Die Veröffentlichung eines Telefonnummers ist ein"
  },
  requirement: {
    nl: "vereiste",
    fr: "exigence",
    en: "requirement",
    de: "Voraussetzung"
  },
  of_FPS_economy: {
    nl: "van FOD Economie",
    fr: "du SPF Economie",
    en: "of FPS Economy",
    de: "von FPS-Wirtschaft"
  },
  do_you_trade_companies_or_consumers: {
    nl: "Handel je met bedrijven of consumenten?",
    fr: "Commercez-vous avec des entreprises ou des consommateurs ?",
    en: "Do you trade with companies or consumers?",
    de: "Handeln Sie mit Unternehmen oder Verbrauchern?"
  },
  i_trade_with_b2b: {
    nl: "Ik handel met bedrijven (B2B)",
    fr: "Je commerce avec des entreprises (B2B)",
    en: "I trade with companies (B2B)",
    de: "Ich handel mit Unternehmen (B2B)"
  },
  i_trade_with_b2c: {
    nl: "Ik handel met consumenten (B2C)",
    fr: "Je commerce avec les consommateurs (B2C)",
    en: "I trade with consumers (B2C)",
    de: "Ich handel mit Verbrauchern (B2C)"
  },
  i_trade_with_both: {
    nl: "Ik handel met bedrijven (B2B) en consumenten (B2C)",
    fr: "Je commerce avec les entreprises (B2B) et les consommateurs (B2C)",
    en: "I trade with companies (B2B) and consumers (B2C)",
    de: "Ich handel mit Unternehmen (B2B) und Verbrauchern (B2C)"
  },
  what_do_you_offer: {
    nl: "Wat bied je aan?",
    fr: "Qu'offres-tu ?",
    en: "What do you offer?",
    de: "Was bieten Sie an?"
  },
  i_offer_both: {
    nl: "Goederen & Diensten",
    fr: "Biens et Services",
    en: "Goods and services",
    de: "Waren und Dienstleistungen"
  },
  i_offer_goods: {
    nl: "Goederen",
    fr: "Biens",
    en: "Goods",
    de: "Waren"
  },
  i_offer_services: {
    nl: "Diensten",
    fr: "Services",
    en: "Services",
    de: "Dienstleistungen"
  },
  you_company_is_now_found_on: {
    nl: "Jouw onderneming wordt nu gevonden op",
    fr: "Votre entreprise sera désormais présente sur",
    en: "Your company is now found on",
    de: "Ihr Unternehmen ist jetzt auf"
  },
  all_activities: {
    nl: "alle activiteiten",
    fr: "toutes les activités",
    en: "all activities",
    de: "alle Aktivitäten"
  },
  that_you_fill_in: {
    nl: "die je aanvult.",
    fr: "que vous réalisez.",
    en: "that you fill in",
    de: "die Sie ausfüllen."
  },
  you_company_is_now_found_on_your_page: {
    nl: "Jouw onderneming wordt nu gevonden op jouw pagina",
    fr: "Votre entreprise sera désormais présente sur votre page",
    en: "Your company is now found on your page",
    de: "Ihr Unternehmen wird jetzt auf Ihrer Seite gefunden"
  },
  public_your_reachability_info: {
    nl: "Publiceer je bereikbaarheid info!",
    fr: "Publiez vos informations de contact !",
    en: "Publish your reachability info!",
    de: "Veröffentlichen Sie Ihre Erreichbarkeitsinformationen!"
  },
  // 04 Activities -----------------------------------------------------------------------------------------
  what_is_your_main_activity: {
    nl: "Wat is jouw voornaamste activiteit?",
    fr: "Quelle est votre activité principale ?",
    en: "What is your main activity?",
    de: "Was ist Ihre Haupttätigkeit?"
  },
  we_searching_and_linking_to_CBE: {
    nl: "Wij zoeken en linken naar de KBO",
    fr: "Nous recherchons et mettons en lien avec la BCE",
    en: "We are searching and linking to the CBE",
    de: "Wir suchen und verlinken zum CBE"
  },
  will_not_be_visible: {
    nl: "Dit wordt niet zichtbaar",
    fr: "Ceci ne sera pas visible",
    en: "This will not be visible",
    de: "Dies wird nicht sichtbar sein"
  },
  what_is_your_first_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (eerste)?",
    fr: "Quelle est votre activité principale (première) ?",
    en: "What is your main activity (first)?",
    de: "Was ist Ihre Haupttätigkeit (erste)?"
  },
  what_is_your_second_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (tweede)?",
    fr: "Quelle est votre activité principale (seconde) ?",
    en: "What is your main activity (second)?",
    de: "Was ist Ihre Haupttätigkeit (zweite)?"
  },
  what_is_your_third_main_activity: {
    nl: "Wat is jouw voornaamste activiteit (derde)?",
    fr: "Quelle est votre activité principale (troisième) ?",
    en: "What is your main activity (third)?",
    de: "Was ist Ihre Haupttätigkeit (dritte)?"
  },
  tell_us_more: {
    nl: "Vertel ons meer",
    fr: "Dites-nous en plus",
    en: "Tell us more",
    de: "Erzählen Sie uns mehr"
  },
  tell_us_more_of_your_activities: {
    nl: "Vertel ons meer over je activiteiten",
    fr: "Dites-nous en plus sur vos activités",
    en: "Tell us more about your activities",
    de: "Erzählen Sie uns mehr über Ihre Aktivitäten"
  },
  what_else_do_you_do: {
    nl: "Wat doe je nog meer?",
    fr: "Que faites-vous d'autre ?",
    en: "What else do you do?",
    de: "Was tun Sie sonst noch?"
  },
  // 05 Opening hours -----------------------------------------------------------------------------------------
  publish_your_opening_hours: {
    nl: "Publiceer jouw openingsuren",
    fr: "Publiez vos heures d'ouverture",
    en: "Publish your opening hours",
    de: "Veröffentlichen Sie Ihre Öffnungszeiten"
  },
  make_sure_all_information_correct: {
    nl: "Maak dat al je gegevens correct zijn!",
    fr: "Assurez-vous que toutes vos informations sont correctes !",
    en: "Make sure all your information is correct!",
    de: "Stellen Sie sicher, dass alle Ihre Informationen korrekt sind!"
  },
  ci_regular_hours: {
    nl: "Reguliere openingstijden",
    fr: "Horaires d'ouverture réguliers",
    en: "Regular opening hours",
    de: "Reguläre Öffnungszeiten"
  },
  ci_opening_hours_special: {
    nl: "Speciale openingstijden",
    fr: "Horaires d'ouverture spéciaux",
    en: "Special opening hours",
    de: "Besondere Öffnungszeiten"
  },
  ci_add_opening_hours: {
    nl: "Openingsuren toevoegen",
    fr: "Ajouter des heures d'ouverture",
    en: "Add opening hours",
    de: "Öffnungszeiten hinzufügen"
  },
  // 06 Address -----------------------------------------------------------------------------------------
  where_can_we_find_you: {
    nl: "Waar kunnen we je vinden?",
    fr: "Où pouvons-nous vous trouver ?",
    en: "Where can we find you?",
    de: "Wo können wir Sie finden?"
  },
  is_your_address_correct: {
    nl: "Is jouw adres correct?",
    fr: "Votre adresse est-elle correcte ?",
    en: "Is your address correct?",
    de: "Ist Ihre Adresse korrekt?"
  },
  public_your_info: {
    nl: "Publiceer je informatie",
    fr: "Publiez vos informations",
    en: "Publish your info",
    de: "Veröffentlichen Sie Ihre Informationen"
  },
  ci_street: {
    nl: "Straat",
    fr: "Rue",
    en: "Street",
    de: "Straße"
  },
  you_company_is_now_found_on_your: {
    nl: "Jouw onderneming wordt nu gevonden op jouw",
    fr: "Votre entreprise est désormais présente sur votre",
    en: "Your company is now found on your",
    de: "Ihr Unternehmen ist jetzt auf Ihrem"
  },
  ci_bus_number: {
    nl: "Bus nummer",
    fr: "Numéro de bus",
    en: "Bus number",
    de: "Busnummer"
  },
  main_activity: {
    nl: "hoofdactiviteit.",
    fr: "activité principale.",
    en: "main activity.",
    de: "Hauptaktivität."
  },
  ci_city: {
    nl: "Stad",
    fr: "Ville",
    en: "City",
    de: "Stadt"
  },
  ci_province: {
    nl: "Provincie",
    fr: "Province",
    en: "Province",
    de: "Provinz"
  },
  ci_country: {
    nl: "Land",
    fr: "Pays",
    en: "Country",
    de: "Land"
  },
  // 07 Photos -----------------------------------------------------------------------------------------
  ci_welcome_photos: {
    nl: "Welkom bij de foto sectie! Voeg hier de foto's toe van jouw onderneming!",
    fr: "Bienvenue dans la section des photos ! Ajoutez ici les photos de votre entreprise !",
    en: "Welcome to the photos section! Add the photos of your company here!",
    de: "Willkommen im Fotobereich! Fügen Sie hier die Fotos Ihres Unternehmens hinzu!"
  },
  ci_upload_photos: {
    nl: "Uploaden foto's",
    fr: "Télécharger des photos",
    en: "Upload photos",
    de: "Fotos hochladen"
  },
  photo_has_to_be_in: {
    nl: "De foto moet in .jpg, .png of .gif-formaat zijn.",
    fr: "La photo doit être au format .jpg, .png ou .gif.",
    en: "The photo has to be in .jpg, .png or .gif format.",
    de: "Das Foto muss im .jpg-, .png- oder .gif-Format vorliegen."
  },
  add_good_photos: {
    nl: "Voeg goede foto's toe, zo breng je je onderneming helemaal in beeld!",
    fr: "Ajoutez de belles photos pour bien représenter votre entreprise !",
    en: "Add good photos, that will really represent your company!",
    de: "Fügen Sie gute Fotos hinzu, die Ihr Unternehmen wirklich repräsentieren!"
  },
  make_sure_no_people_visible: {
    nl: "Zorg ervoor dat er geen mensen op de foto's staan!",
    fr: "Assurez-vous qu'aucune personne n'est visible sur les photos !",
    en: "Make sure no people are visible in the photos!",
    de: "Stellen Sie sicher, dass keine Personen auf den Fotos zu sehen sind!"
  },
  we_dont_publish_photos: {
    nl: "Wij publiceren geen foto's waar mensen op staan",
    fr: "Nous ne publions pas de photos où des personnes sont visibles",
    en: "We don't publish photos where people are visible",
    de: "Wir veröffentlichen keine Fotos, auf denen Personen zu sehen sind"
  },
  make_sure_no_people_visible_part_2: {
    nl: "tenzij jij ons hiervoor expliciet toelating geeft en de personen op de foto geen bezwaren hebben.",
    fr: "à moins que vous ne nous donniez votre accord explicite et que les personnes sur la photo ne s'y opposent pas.",
    en: "unless you explicitly give us permission and the people in the photo have no objections.",
    de: "es sei denn, Sie geben uns ausdrücklich Ihre Erlaubnis und die Personen auf dem Foto haben keine Einwände."
  },
  the_photos_will_be_verified: {
    nl: "De foto's zullen door ons team gecontroleerd worden alvorens ze online geplaatst worden.",
    fr: "Les photos seront vérifiées par notre équipe avant d'être mises en ligne.",
    en: "The photos will be verified by our team before being posted online.",
    de: "Die Fotos werden von unserem Team überprüft, bevor sie online gestellt werden."
  },
  // 08 Logos -----------------------------------------------------------------------------------------
  public_your_logo: {
    nl: "Publiceer jouw logo",
    fr: "Publiez votre logo",
    en: "Publish your logo",
    de: "Veröffentlichen Sie Ihr Logo"
  },
  the_logo_has_to_be_in: {
    nl: "Het logo moet in .ai, .eps, .svg of .pdf-vector formaat zijn.",
    fr: "Le logo doit être au format .ai, .eps, .svg ou .pdf vector.",
    en: "The logo has to be in .ai, .eps, .svg or .pdf vector format.",
    de: "Das Logo muss im .ai-, .eps-, .svg- oder .pdf-Vektorformat vorliegen."
  },
  add_good_logo: {
    nl: "Voeg een goed logo toe, zodat jouw onderneming er staat!",
    fr: "Ajoutez un bon logo pour que votre entreprise se démarque !",
    en: "Add a good logo so your company stands out!",
    de: "Fügen Sie ein gutes Logo hinzu, damit Ihr Unternehmen hervorsticht!"
  },
  the_logo_will_be_verified: {
    nl: "Het logo zal door ons team gecontroleerd worden alvorens het online geplaatst wordt.",
    fr: "Le logo sera vérifié par notre équipe avant d'être mis en ligne.",
    en: "The logo will be verified by our team before being posted online.",
    de: "Das Logo wird von unserem Team überprüft, bevor es online gestellt wird."
  },
  // 09 Social -----------------------------------------------------------------------------------------
  the_website_will_be_linked: {
    nl: "De website wordt rechtstreeks gelinkt en is eenvoudig aan te passen in jouw portaal.",
    fr: "Le site Web sera directement lié et facile à modifier dans votre portail.",
    en: "The website will be directly linked and is easy to adjust in your portal.",
    de: "Die Website wird direkt verlinkt und lässt sich in Ihrem Portal einfach anpassen."
  },
  facebook: {
    nl: "Facebook",
    fr: "Facebook",
    en: "Facebook",
    de: "Facebook"
  },
  instagram: {
    nl: "Instagram",
    fr: "Instagram",
    en: "Instagram",
    de: "Instagram"
  },
  linkedin: {
    nl: "LinkedIn",
    fr: "LinkedIn",
    en: "LinkedIn",
    de: "LinkedIn"
  },
  ci_facebook: {
    nl: "Facebook link",
    fr: "Lien Facebook",
    en: "Facebook link",
    de: "Facebook-Link"
  },
  ci_instagram: {
    nl: "Instagram link",
    fr: "Lien Instagram",
    en: "Instagram link",
    de: "Instagram-Link"
  },
  ci_linkedin: {
    nl: "LinkedIn link",
    fr: "Lien LinkedIn",
    en: "LinkedIn link",
    de: "LinkedIn-Link"
  },
  add_your_social_media: {
    nl: "Voeg jouw social media kanalen toe",
    fr: "Ajoutez vos chaînes de médias sociaux",
    en: "Add your social media channels",
    de: "Fügen Sie Ihre Social-Media-Kanäle hinzu"
  },
  // 10 Delivery -----------------------------------------------------------------------------------------
  do_you_do_deliveries: {
    nl: "Doe jij leveringen?",
    fr: "Faites-vous des livraisons ?",
    en: "Do you do deliveries?",
    de: "Liefern Sie?"
  },
  free: {
    nl: "GRATIS",
    fr: "GRATUIT",
    en: "FREE",
    de: "Frei"
  },
  paying: {
    nl: "BETALEND",
    fr: "PAYANT",
    en: "PAYING",
    de: "zahlend"
  },
  choice_for_paying: {
    nl: "Jouw keuze voor betalend",
    fr: "Votre choix pour payer",
    en: "Your choice for paying",
    de: "Ihre Wahl für bezahlbar"
  },
  commit_you_to_nothing: {
    nl: '"VERPLICHT JE TOT NIETS"!',
    fr: '"NE VOUS ENGAGEZ A RIEN" !',
    en: '"COMMITS YOU TO NOTHING"!',
    de: '"VERLIEST SIE SICH NICHT AUF"!'
  },
  the_choice_to_link_your_company: {
    nl: 'De keuze om jouw onderneming aan meerdere activiteiten te koppelen geeft uitsluitend aan dat je een vrijblijvend bezoek van onze raadgever vraagt. Tijdens dit bezoek krijg je alle informatie en kan je nog steeds terugschakelen naar de keuze voor "GRATIS" op basis van jouw hoofdactiviteit.',
    fr: 'Le choix de lier votre entreprise à plusieurs activités indique uniquement que vous demandez une visite sans engagement de notre conseiller. Au cours de cette visite, vous obtiendrez toutes les informations et vous pourrez toujours revenir au choix "GRATUIT" en fonction de votre activité principale.',
    en: 'The choice to link your company to several activities only indicates that you request a non-binding visit from our advisor. During this visit you will get all the information and you can still switch back to the choice for "FREE" based on your main activity.',
    de: 'Die Wahl, Ihre Firma mit mehreren Aktivitäten zu verknüpfen, gibt nur an, dass Sie eine nicht-bindende Besuch von unserem Berater beantragen. Während dieses Besuchs erhalten Sie alle Informationen und können immer noch zur Wahl für "GRATIS" zurückkehren, basierend auf Ihrer Hauptaktivität.'
  },
  your_main_activity: {
    nl: "Jouw hoofdactiviteit:",
    fr: "Votre activité principale :",
    en: "Your main activity:",
    de: "Ihre Hauptaktivität:"
  },
  wish_to_modify_your_activity: {
    nl: "Wens je jouw activiteit aan te passen?",
    fr: "Vous souhaitez adapter votre activité ?",
    en: "Do you wish to modify your activity?",
    de: "Möchten Sie Ihre Aktivität ändern?"
  },
  already_modified_your_activity: {
    nl: "Je hebt jouw activiteit al aangepast!",
    fr: "Vous avez déjà modifié votre activité !",
    en: "You have already modified your activity!",
    de: "Sie haben Ihre Aktivität bereits geändert!"
  },
  your_activities_retrieved_from_CBE: {
    nl: "Jouw activiteiten opgehaald uit KBO:",
    fr: "Collecte de vos activités via BCE :",
    en: "Your activities retrieved from CBE:",
    de: "Ihre Aktivitäten aus CBE abgerufen:"
  },
  here_you_can_add_multiple_activities: {
    nl: "Hier kan je meerdere activiteiten toevoegen. Bij invoer van een trefwoord kan je kiezen uit de verschillende suggesties:",
    fr: "Ici, vous pouvez ajouter plusieurs activités. Lors de la saisie d'un mot clé, vous pouvez choisir parmi les différentes suggestions :",
    en: "Here you can add multiple activities. When entering a keyword you can choose from the various suggestions:",
    de: "Hier können Sie mehrere Aktivitäten hinzufügen. Wenn Sie ein Schlüsselwort eingeben, können Sie aus verschiedenen Vorschlägen wählen:"
  },
  do_you_wish_to_modify_or_add_an_activity: {
    nl: "Wens je een activiteit aan te passen of toe te voegen",
    fr: "Vous souhaitez modifier ou ajouter une activité ?",
    en: "Do you wish to modify or add an activity?",
    de: "Möchten Sie eine Aktivität ändern oder hinzufügen?"
  },
  fsma_registration: {
    nl: "FSMA registratie",
    fr: "Enregistrement FSMA",
    en: "FSMA registration",
    de: "FSMA-Registrierung"
  },
  apb_registration: {
    nl: "APB registratie",
    fr: "Enregistrement APB",
    en: "APB registration",
    de: "APB-Registrierung"
  },
  itaa_registration: {
    nl: "ITAA registratie",
    fr: "Enregistrement ITAA",
    en: "ITAA registration",
    de: "ITAA-Registrierung"
  },
  epc_registration: {
    nl: "EPC registratie",
    fr: "Enregistrement EPC",
    en: "EPC registration",
    de: "EPC-Registrierung"
  },
  biv_registration: {
    nl: "BIV registratie",
    fr: "Enregistrement IPI",
    en: "BIV registration",
    de: "BIV-Registrierung"
  },
  your_choice_for_extra_activities: {
    nl: "Jouw keuze voor extra activiteiten: (geen beperking bij betalende optie)",
    fr: "Votre choix d'activités supplémentaires : (pas de limitation avec option payante)",
    en: "Your choice for extra activities: (no limitation with paying option)",
    de: "Ihre Wahl für zusätzliche Aktivitäten: (keine Begrenzung mit der Option für bezahlbar)"
  }
}, _defineProperty(_CustomerInfo, "here_you_can_add_multiple_activities", {
  nl: "Hier kan je meerdere activiteiten toevoegen. Bij invoer van een trefwoord kan je kiezen uit de verschillende suggesties:",
  fr: "Ici, vous pouvez ajouter plusieurs activités. Lors de la saisie d'un mot clé, vous pouvez choisir parmi les différentes suggestions :",
  en: "Here you can add multiple activities. When entering a keyword you can choose from the various suggestions:",
  de: "Hier können Sie mehrere Aktivitäten hinzufügen. Wenn Sie ein Schlüsselwort eingeben, können Sie aus verschiedenen Vorschlägen wählen:"
}), _defineProperty(_CustomerInfo, "where_can_visitors_reach_you", {
  nl: "Waar kunnen bezoekers jou bereiken?",
  fr: "Les visiteurs, où peuvent-ils vous joindre ?",
  en: "Where can visitors reach you?",
  de: "Wo können Besucher Sie erreichen?"
}), _defineProperty(_CustomerInfo, "important_right_location", {
  nl: "Het is belangrijk dat bezoekers jou op de juiste locatie kunnen vinden!",
  fr: "Il est important que les visiteurs puissent vous trouver au bon endroit !",
  en: "It is important that visitors can find you in the right location!",
  de: "Es ist wichtig, dass Besucher Sie in der richtigen Position finden können!"
}), _defineProperty(_CustomerInfo, "through_the_map_position_marker", {
  nl: "Via de kaart is het mogelijk om de positie van de marker (pointer) te corrigeren. De coördinaten zullen automatisch worden gecorrigeerd.",
  fr: "Via la carte, il est possible de corriger la position du marqueur (pointeur). Les coordonnées seront corrigées automatiquement.",
  en: "Through the map it is possible to correct the position of the marker (pointer). The coordinates will be corrected automatically.",
  de: "Durch die Karte ist es möglich, die Position des Markers (Zeiger) zu korrigieren. Die Koordinaten werden automatisch korrigiert."
}), _defineProperty(_CustomerInfo, "ci_streetname", {
  nl: "Straatnaam",
  fr: "Nom de rue",
  en: "Street",
  de: "Straße"
}), _defineProperty(_CustomerInfo, "ci_house_number", {
  nl: "Huisnr",
  fr: "N° de maison",
  en: "House number",
  de: "Hausnummer"
}), _defineProperty(_CustomerInfo, "ci_box", {
  nl: "Bus",
  fr: "Box",
  en: "Box",
  de: "Box"
}), _defineProperty(_CustomerInfo, "ci_postal_code", {
  nl: "Postcode",
  fr: "Code postal",
  en: "Postal code",
  de: "Postleitzahl"
}), _defineProperty(_CustomerInfo, "ci_sub_municipality", {
  nl: "Deelgemeente",
  fr: "Sous-municipalité",
  en: "Submunicipality",
  de: "Gemeinde"
}), _defineProperty(_CustomerInfo, "ci_municipality", {
  nl: "Stad of gemeente",
  fr: "Ville our municipalité",
  en: "City or municipality",
  de: "Stadt oder Gemeinde"
}), _defineProperty(_CustomerInfo, "ci_extra_address_info", {
  nl: "Extra adres info",
  fr: "Informations d'adresse supplémentaires",
  en: "Additional address info",
  de: "Zusätzliche Adressinformationen"
}), _defineProperty(_CustomerInfo, "ci_example_extra_address_info", {
  nl: "Voorbeeld: Ingang langs een zijstraat -",
  fr: "Exemple : Entrée le long d'une rue secondaire -",
  en: "Example: Entrance along a side street -",
  de: "Beispiel: Eingang auf einer Seitenstraße -"
}), _defineProperty(_CustomerInfo, "ci_example_extra_address_info_part2", {
  nl: "Bekijk een live voorbeeld",
  fr: "Regarder un aperçu en direct",
  en: " Watch a live preview",
  de: "Schauen Sie sich einen Live-Vorschau an"
}), _defineProperty(_CustomerInfo, "ci_address_info_marker", {
  nl: "Klik op het markericoontje rechtsonder de kaart en vervolgens op de correcte positie indien je dit wil wijzigen.",
  fr: "Cliquez sur l'icône du marqueur en bas à droite de la carte puis sur la bonne position si vous souhaitez la modifier.",
  en: "Click on the marker icon at the bottom right of the map and then on the correct position if you want to change this.",
  de: "Klicken Sie auf das Marker-Symbol rechts unten auf der Karte und dann auf die richtige Position, wenn Sie dies ändern möchten."
}), _defineProperty(_CustomerInfo, "with_you_logo_you_stand_out_more", {
  nl: "Met jouw logo val je meer op!",
  fr: "Avec votre logo vous vous démarquez davantage !",
  en: "With your logo you stand out more!",
  de: "Mit Ihrem Logo steigen Sie weiter!"
}), _defineProperty(_CustomerInfo, "about_85_percent", {
  nl: "Ongeveer 85% van de ondernemingen heeft een logo als identificatie. Hiermee trek je ook meer de aandacht.",
  fr: "Environ 85% des entreprises ont un logo d'identification. Cela attirera également plus d'attention.",
  en: "About 85% of the companies have a logo as identification. This will also attract more attention.",
  de: "Ungefähr 85% der Unternehmen haben ein Logo als Identifizierung. Dies wird auch mehr Aufmerksamkeit erregen."
}), _defineProperty(_CustomerInfo, "with_your_logo", {
  nl: "Met jouw LOGO kom je ook",
  fr: "Avec votre LOGO, vous êtes",
  en: "With your LOGO, you are",
  de: "Mit Ihrem LOGO sind Sie"
}), _defineProperty(_CustomerInfo, "guaranteed", {
  nl: "GEGARANDEERD",
  fr: "GARANTI",
  en: "GUARANTEED",
  de: "GARANTIERT"
}), _defineProperty(_CustomerInfo, "front_of_the_results", {
  nl: "vooraan in de zoekresultaten!",
  fr: "d'être en tête des résultats de recherche !",
  en: "to be at the front of the search results!",
  de: "zur ersten Stelle in den Suchergebnissen!"
}), _defineProperty(_CustomerInfo, "company_has_a_logo", {
  nl: "Heeft jouw onderneming of vestiging een logo?",
  fr: "Votre entreprise ou établissement a-t-elle un logo ?",
  en: "Does your company or establishment have a logo?",
  de: "Hat Ihre Firma oder Einrichtung ein Logo?"
}), _defineProperty(_CustomerInfo, "upload_logo_here", {
  nl: "Laad jouw logo zelf op:",
  fr: "Téléchargez votre logo ici :",
  en: "Upload your logo here:",
  de: "Laden Sie Ihr Logo hier hoch:"
}), _defineProperty(_CustomerInfo, "allowed_file_formats", {
  nl: "Toegestane bestandsformaten: .ai-.svg-.cdr-.eps-.pdf (geen .jpg of .png)",
  fr: "Formats de fichiers autorisés : .ai-.svg-.cdr-.eps-.pdf (pas de .jpg ou .png)",
  en: "Allowed file formats: .ai-.svg-.cdr-.eps-.pdf (no .jpg or .png)",
  de: "Erlaubte Dateiformate: .ai-.svg-.cdr-.eps-.pdf (kein .jpg oder .png)"
}), _defineProperty(_CustomerInfo, "attention", {
  nl: "AANDACHT!",
  fr: "ATTENTION !",
  en: "ATTENTION!",
  de: "ACHTUNG!"
}), _defineProperty(_CustomerInfo, "logo_will_be_checked", {
  nl: "jouw logo wordt eerst nagekeken. Na validatie komt dit zichtbaar!",
  fr: "Votre logo sera vérifié en premier. Celui-ci sera visible après validation !",
  en: "Your logo will be checked first. This will be visible after validation!",
  de: "Ihr Logo wird zuerst überprüft. Dies wird nach der Validierung sichtbar sein!"
}), _defineProperty(_CustomerInfo, "logo_uploaded_by", {
  nl: "Logo opgeladen door:",
  fr: "Logo téléchargé par :",
  en: "Logo uploaded by:",
  de: "Logo hochgeladen von:"
}), _defineProperty(_CustomerInfo, "our_database", {
  nl: "ONZE DATABASE",
  fr: "NOTRE BASE DE DONNÉES",
  en: "OUR DATABASE",
  de: "UNSER DATENBANK"
}), _defineProperty(_CustomerInfo, "ci_entrepreneur", {
  nl: "ONDERNEMER",
  fr: "CHEF D'ENTREPRISE",
  en: "ENTREPRENEUR",
  de: "EINENTRETENDER"
}), _defineProperty(_CustomerInfo, "save_my_logo", {
  nl: "bewaar mijn logo",
  fr: "enregistrer mon logo",
  en: "save my logo",
  de: "Speichern Sie mein Logo"
}), _defineProperty(_CustomerInfo, "contact_my_printer", {
  nl: "Contacteer mijn drukker/grafisch bureau om mijn logo op te vragen:",
  fr: "Contactez mon imprimeur/agence graphique pour demander mon logo :",
  en: "Contact my printer/graphics agency to request my logo:",
  de: "Kontaktieren Sie meinen Drucker/Grafikbüro, um mein Logo anzufordern:"
}), _defineProperty(_CustomerInfo, "company_name_or_responsible_person", {
  nl: "Bedrijfsnaam of verantwoordelijke",
  fr: "Nom de l'entreprise ou personne responsable",
  en: "Company name or responsible person",
  de: "Firmenname oder verantwortliche Person"
}), _defineProperty(_CustomerInfo, "yes", {
  nl: "Ja",
  fr: "Oui",
  en: "Yes",
  de: "Ja"
}), _defineProperty(_CustomerInfo, "i_accept", {
  nl: "Ik aanvaard",
  fr: "J'accepte",
  en: "I accept",
  de: "Ich akzeptiere"
}), _defineProperty(_CustomerInfo, "i_reject", {
  nl: "Ik weiger",
  fr: "Je refuse",
  en: "I reject",
  de: "Ich lehne ab"
}), _defineProperty(_CustomerInfo, "can_we_publish", {
  nl: "Mogen wij dat publiceren?",
  fr: "Pouvons-nous publier cela ?",
  en: "Can we publish that?",
  de: "Können wir das veröffentlichen?"
}), _defineProperty(_CustomerInfo, "can_we_publish_your_deliveries", {
  nl: "Mogen wij jouw leveringen publiceren?",
  fr: "Pouvons-nous publier vos livraisons ?",
  en: "Can we publish your deliveries?",
  de: "Können wir Ihre Lieferungen veröffentlichen?"
}), _defineProperty(_CustomerInfo, "can_we_publish_your_deliveries_part_2", {
  nl: "Let wel! Het publiceren van jouw leveringsinformatie genereert extra omzet voor jouw onderneming!",
  fr: "Attention ! La publication de vos informations de livraison génère des revenus supplémentaires pour votre entreprise !",
  en: "Please note! Publishing your delivery information generates additional revenue for your company!",
  de: "Bitte beachten Sie! Die Veröffentlichung Ihrer Lieferinformationen generiert zusätzliche Einnahmen für Ihr Unternehmen!"
}), _defineProperty(_CustomerInfo, "ci_delivery", {
  nl: "Levering",
  fr: "Livraison",
  en: "Delivery",
  de: "Lieferung"
}), _defineProperty(_CustomerInfo, "ci_pickup", {
  nl: "Afhalen",
  fr: "Ramasser",
  en: "Pickup",
  de: "Abholung"
}), _defineProperty(_CustomerInfo, "ci_delivery_fee", {
  nl: "Leveringskost",
  fr: "Frais de livraison",
  en: "Delivery fee",
  de: "Liefergebühr"
}), _defineProperty(_CustomerInfo, "ci_payment_methods", {
  nl: "Betalingsmethodes",
  fr: "Méthodes de payement",
  en: "Payment methods",
  de: "Zahlungsmethoden"
}), _defineProperty(_CustomerInfo, "ci_online_payment", {
  nl: "Online betaling",
  fr: "Paiement en ligne",
  en: "Online payment",
  de: "Online-Zahlung"
}), _defineProperty(_CustomerInfo, "ci_online_payment_possible", {
  nl: "Online betaling mogelijk",
  fr: "Paiement en ligne possible",
  en: "Online payment possible",
  de: "Online-Zahlung möglich"
}), _defineProperty(_CustomerInfo, "ci_cash", {
  nl: "Contant",
  fr: "Espèces",
  en: "Cash",
  de: "Bargeld"
}), _defineProperty(_CustomerInfo, "ci_bancontact", {
  nl: "Bancontact",
  fr: "Bancontact",
  en: "Bancontact",
  de: "Bancontact"
}), _defineProperty(_CustomerInfo, "ci_visa", {
  nl: "Visa",
  fr: "Visa",
  en: "Visa",
  de: "Visum"
}), _defineProperty(_CustomerInfo, "ci_paypal", {
  nl: "PayPal",
  fr: "PayPal",
  en: "PayPal",
  de: "PayPal"
}), _defineProperty(_CustomerInfo, "ci_credit_card", {
  nl: "Kredietkaart",
  fr: "Carte de crédit",
  en: "Credit card",
  de: "Kreditkarte"
}), _defineProperty(_CustomerInfo, "ci_bank_transfer", {
  nl: "Bankoverschrijving",
  fr: "Virement bancaire",
  en: "Bank transfer",
  de: "Banküberweisung"
}), _defineProperty(_CustomerInfo, "ci_apple_pay", {
  nl: "Apple Pay",
  fr: "Apple Pay",
  en: "Apple Pay",
  de: "Apple Pay"
}), _defineProperty(_CustomerInfo, "ci_google_pay", {
  nl: "Google Pay",
  fr: "Google Pay",
  en: "Google Pay",
  de: "Google Pay"
}), _defineProperty(_CustomerInfo, "ci_payconiq", {
  nl: "Payconiq",
  fr: "Payconiq",
  en: "Payconiq",
  de: "Payconiq"
}), _defineProperty(_CustomerInfo, "ci_meal_voucher", {
  nl: "Maaltijdcheque",
  fr: "Chèque-repas",
  en: "Meal voucher",
  de: "Essensgutschein"
}), _defineProperty(_CustomerInfo, "ci_ecocheque", {
  nl: "Ecocheque",
  fr: "Écocheque",
  en: "Ecocheque",
  de: "Ökocheck"
}), _defineProperty(_CustomerInfo, "ci_add_product", {
  nl: "Product toevoegen",
  fr: "Ajouter un produit",
  en: "Add product",
  de: "Produkt hinzufügen"
}), _defineProperty(_CustomerInfo, "ci_add_service", {
  nl: "Dienst toevoegen",
  fr: "Ajouter un service",
  en: "Add service",
  de: "Dienst hinzufügen"
}), _defineProperty(_CustomerInfo, "ci_description_product", {
  nl: "Beschrijf jouw product",
  fr: "Décrivez votre produit",
  en: "Describe your product",
  de: "Beschreiben Sie Ihr Produkt"
}), _defineProperty(_CustomerInfo, "ci_description_service", {
  nl: "Beschrijf jouw dienst",
  fr: "Décrivez votre service",
  en: "Describe your service",
  de: "Beschreiben Sie Ihren Dienst"
}), _defineProperty(_CustomerInfo, "ci_add_photo", {
  nl: "Foto toevoegen",
  fr: "Ajouter une photo",
  en: "Add photo",
  de: "Foto hinzufügen"
}), _defineProperty(_CustomerInfo, "ci_faq", {
  nl: "FAQ",
  fr: "FAQ",
  en: "FAQ",
  de: "FAQ"
}), _defineProperty(_CustomerInfo, "ci_contact_info", {
  nl: "Contact informatie",
  fr: "Informations de contact",
  en: "Contact info",
  de: "Kontaktinformation"
}), _defineProperty(_CustomerInfo, "ci_email_invoice", {
  nl: "Factuur e-mail",
  fr: "E-mail de facturation",
  en: "Invoice e-mail",
  de: "Rechnungs-E-Mail"
}), _defineProperty(_CustomerInfo, "ci_email_support", {
  nl: "Support e-mail",
  fr: "E-mail de support",
  en: "Support e-mail",
  de: "Support-E-Mail"
}), _defineProperty(_CustomerInfo, "you_will_automatically_receive_a", {
  nl: "Je krijgt automatisch een",
  fr: "Vous recevrez automatiquement une",
  en: "You will automatically receive a",
  de: "Sie erhalten automatisch eine"
}), _defineProperty(_CustomerInfo, "ci_copy", {
  nl: "kopie",
  fr: "copie",
  en: "copy",
  de: "Kopie"
}), _defineProperty(_CustomerInfo, "of_this_email", {
  nl: "van deze mail",
  fr: "de cet e-mail",
  en: "of this e-mail",
  de: "dieser E-Mail"
}), _defineProperty(_CustomerInfo, "email_contact_person", {
  nl: "Email van je contactpersoon",
  fr: "E-mail de votre personne de contact",
  en: "E-mail of your contact person",
  de: "E-Mail Ihrer Kontaktperson"
}), _defineProperty(_CustomerInfo, "this_is_the_data", {
  nl: "Dit zijn de gegevens",
  fr: "Ceci sont les données",
  en: "This is the data",
  de: "Die sind die Daten"
}), _defineProperty(_CustomerInfo, "but_i_am_interested", {
  nl: ". . . maar ik heb interesse!",
  fr: ". . . mais je suis intéressé !",
  en: ". . . but i'm interested!",
  de: ". . . aber ich bin interessiert!"
}), _defineProperty(_CustomerInfo, "you_want_unique_logo", {
  nl: "Jij wil een uniek en toepasselijk logo laten maken.",
  fr: "Vous souhaitez faire créer un logo unique et approprié.",
  en: "You want to have a unique and appropriate logo made.",
  de: "Sie möchten ein einzigartiges und angemessenes Logo erstellen."
}), _defineProperty(_CustomerInfo, "you_can_contact_us_for_this", {
  nl: "Hiervoor kan kan je bij ons terecht!",
  fr: "Vous pouvez nous contacter pour cela !",
  en: "You can contact us for this!",
  de: "Sie können uns für diesen Kontakt aufnehmen!"
}), _defineProperty(_CustomerInfo, "idb_shows_some_creations", {
  nl: "idBForge toont hieronder enkele van haar creaties.",
  fr: "idBForge montre quelques-unes de ses créations ci-dessous.",
  en: "idBForge shows some of her creations below.",
  de: "idBForge zeigt einige ihrer Kreationen unten."
}), _defineProperty(_CustomerInfo, "contact_me_for_proposal", {
  nl: "Contacteer mij om een voorstel te ontvangen.",
  fr: "Contactez-moi pour recevoir une proposition.",
  en: "Contact me to receive a proposal.",
  de: "Kontaktieren Sie mich, um einen Vorschlag zu erhalten."
}), _defineProperty(_CustomerInfo, "and_i_am_not_interested", {
  nl: ". . . en ik heb geen intresse!",
  fr: ". . . et je ne suis pas intéressé !",
  en: ". . . and I'm not interested!",
  de: ". . . und ich bin nicht interessiert!"
}), _defineProperty(_CustomerInfo, "with_a_logo_you", {
  nl: "Met een logo trek je altijd meer bezoekers aan!",
  fr: "Avec un logo, vous attirez toujours plus de visiteurs !",
  en: "With a logo you always attract more visitors!",
  de: "Mit einem Logo treffen Sie immer mehr Besucher!"
}), _defineProperty(_CustomerInfo, "without_logo", {
  nl: "Zonder logo tonen wij de volgende afbeelding:",
  fr: "Sans logo, nous montrons l'image suivante :",
  en: "Without logo, we show the following image:",
  de: "Ohne Logo zeigen wir die folgende Abbildung:"
}), _defineProperty(_CustomerInfo, "yes_i_am_sure", {
  nl: "JA, IK BEN ZEKER!",
  fr: "OUI, JE SUIS SÛR !",
  en: "YES I AM SURE!",
  de: "JA, ICH BIN DIR BESCHWERDET!"
}), _defineProperty(_CustomerInfo, "add_your_internet_links", {
  nl: "Voeg jouw internet koppelingen toe",
  fr: "Ajoutez vos liens internet",
  en: "Add your internet links",
  de: "Fügen Sie Ihre Internet-Links hinzu"
}), _defineProperty(_CustomerInfo, "show_your_visitors", {
  nl: "Toon jouw bezoekers de verschillende kanalen waar je onderneming op het internet kan gevonden worden.",
  fr: "Montrez à vos visiteurs les différents canaux où votre entreprise peut être trouvée sur Internet.",
  en: "Show your visitors the different channels where your company can be found on the internet.",
  de: "Zeigen Sie Ihren Besuchern die verschiedenen Kanäle, auf denen Ihre Firma im Internet gefunden werden kann."
}), _defineProperty(_CustomerInfo, "as_a_check", {
  nl: "Bezoek als controle je persoonlijke pagina's per kanaal en kopieer de volledige link inclusief",
  fr: "Pour vérifier, visitez vos pages personnelles par canal et copiez le lien complet, y compris",
  en: "As a check, visit your personal pages per channel and copy the full link including",
  de: "Als Prüfung besuchen Sie Ihre persönlichen Seiten pro Kanal und kopieren Sie den vollständigen Link einschließlich"
}), _defineProperty(_CustomerInfo, "http_https", {
  nl: "http of https.",
  fr: "http ou https.",
  en: "http or https.",
  de: "http oder https."
}), _defineProperty(_CustomerInfo, "ci_website", {
  nl: "Website",
  fr: "Site web",
  en: "Website",
  de: "Website"
}), _defineProperty(_CustomerInfo, "ci_save", {
  nl: "Opslaan",
  fr: "Sauvegarder",
  en: "Save",
  de: "Speichern"
}), _defineProperty(_CustomerInfo, "website", {
  nl: "Website",
  fr: "Site web",
  en: "Website",
  de: "Webseite"
}), _defineProperty(_CustomerInfo, "ci_webshop", {
  nl: "Webshop",
  fr: "Webshop",
  en: "Webshop",
  de: "Webshop"
}), _defineProperty(_CustomerInfo, "webshop", {
  nl: "Webshop",
  fr: "Webshop",
  en: "Webshop",
  de: "Webshop"
}), _defineProperty(_CustomerInfo, "contacts", {
  nl: "Contactpersonen",
  fr: "Contacts",
  en: "Contacts",
  de: "Kontakte"
}), _defineProperty(_CustomerInfo, "because_certain_companies", {
  nl: "Omdat bepaalde ondernemingen er de voorkeur aan geven om te verwijzen naar een contactpersoon is het mogelijk om hieronder deze gegevens in te vullen.",
  fr: "Parce que certaines entreprises préfèrent se référer à une personne de contact, il est possible de renseigner ces informations ci-dessous.",
  en: "Because certain companies prefer to refer to a contact person, it is possible to fill in this information below.",
  de: "Da es sich um bestimmte Unternehmen handelt, ist es möglich, diese Informationen unten zu füllen."
}), _defineProperty(_CustomerInfo, "eg", {
  nl: "bv.",
  fr: "par exemple :",
  en: "eg:",
  de: "z.B.:"
}), _defineProperty(_CustomerInfo, "a_department_manager", {
  nl: "een verantwoordelijke van een afdeling...",
  fr: "un responsable de département...",
  en: "a department manager...",
  de: "ein Verantwortlicher eines Abteilungsleiters..."
}), _defineProperty(_CustomerInfo, "add", {
  nl: "Toevoegen",
  fr: "Ajouter",
  en: "Add",
  de: "Hinzufügen"
}), _defineProperty(_CustomerInfo, "function", {
  nl: "Functie",
  fr: "Fonction",
  en: "Function",
  de: "Funktion"
}), _defineProperty(_CustomerInfo, "department", {
  nl: "Afdeling",
  fr: "Département",
  en: "Department",
  de: "Abteilung"
}), _defineProperty(_CustomerInfo, "date_of_birth", {
  nl: "Geboortedatum ",
  fr: "Date de naissance",
  en: "Date of birth",
  de: "Geburtsdatum"
}), _defineProperty(_CustomerInfo, "date_of_birth_not_published", {
  nl: "Geboortedatum (wordt niet gepubliceerd)",
  fr: "Date de naissance (ne sera pas publié)",
  en: "Date of birth (will not be published)",
  de: "Geburtsdatum (wird nicht veröffentlicht)"
}), _defineProperty(_CustomerInfo, "avatar", {
  nl: "Afbeelding of avatar",
  fr: "Image ou avatar",
  en: "Image or avatar",
  de: "Bild oder Avatar"
}), _defineProperty(_CustomerInfo, "spoken_languages", {
  nl: "Gesproken talen",
  fr: "Langue parlée",
  en: "Spoken languages",
  de: "Gesprochene Sprachen"
}), _defineProperty(_CustomerInfo, "offers_the", {
  nl: "biedt de",
  fr: "vous propose le",
  en: "offers the",
  de: "bietet die"
}), _defineProperty(_CustomerInfo, "i_allow_my_customers", {
  nl: "Ik sta toe dat mijn klanten hiermee kunnen betalen.",
  fr: "Je permets à mes clients de payer avec ça.",
  en: "I allow my customers to pay with this.",
  de: "Ich erlaube meine Kunden, mit dieser zu bezahlen."
}), _defineProperty(_CustomerInfo, "what_facilities", {
  nl: "Welke faciliteiten, diensten, associaties... bied je als extra aan?",
  fr: "Quels équipements complémentaires, services, associations... proposez-vous ?",
  en: "What additional facilities, services, associations... do you offer?",
  de: "Welche zusätzlichen Dienstleistungen, Dienste, Vereine... bieten Sie an?"
}), _defineProperty(_CustomerInfo, "not_just_payment_facilities", {
  nl: "Het zijn niet alleen betaalfaciliteiten waar men in dit digitale tijdperk naar uitkijkt.",
  fr: "Ce ne sont pas seulement les facilités de paiement que les gens attendent avec impatience à l'ère numérique.",
  en: "It is not just payment facilities that people are looking forward to in this digital age.",
  de: "Es sind nicht nur Zahlungsfähigkeiten, die Leute in dieser digitalen Zeit nach einem Ausflug suchen."
}), _defineProperty(_CustomerInfo, "many_other_services", {
  nl: "Heel wat andere diensten die jij aanbiedt kunnen belangrijk zijn om te communiceren met potentiële klanten.",
  fr: "De nombreux autres services que vous proposez peuvent être importants pour communiquer avec des clients potentiels.",
  en: "Many other services you offer can be important for communicating with potential customers.",
  de: "Viele andere Dienste, die Sie anbieten, können für die Kommunikation mit potenziellen Kunden wichtig sein."
}), _defineProperty(_CustomerInfo, "give_them_as_much_as_paossible", {
  nl: "Geef hen zoveel mogelijk informatie!",
  fr: "Donnez-leur le maximum d'informations !",
  en: "Give them as much information as possible!",
  de: "Geben Sie ihnen so viel Informationen wie möglich!"
}), _defineProperty(_CustomerInfo, "ci_search", {
  nl: "Zoeken",
  fr: "Chercher",
  en: "Search",
  de: "Suchen"
}), _defineProperty(_CustomerInfo, "please_enter_facility", {
  nl: "Voeg de naam in van jouw extra faciliteit",
  fr: "Veuillez entrer le nom de votre établissement supplémentaire",
  en: "Please enter the name of your additional facility",
  de: "Bitte geben Sie den Namen Ihres zusätzlichen Einrichtungsorts ein"
}), _defineProperty(_CustomerInfo, "other_possibilities", {
  nl: "Andere mogelijkheden?",
  fr: "D'autres possibilités ?",
  en: "Other possibilities?",
  de: "Andere Möglichkeiten?"
}), _defineProperty(_CustomerInfo, "everyting_checked", {
  nl: "Alles wordt eerst gecontroleerd vooraleer het online wordt geplaatst.",
  fr: "Tout est d'abord vérifié avant d'être mis en ligne.",
  en: "Everything is first checked before it is placed online.",
  de: "Alles wird zuerst überprüft, bevor es online geplant wird."
}), _defineProperty(_CustomerInfo, "ci_timetables", {
  nl: "Tijdschema's",
  fr: "Horaires",
  en: "Timetables",
  de: "Zeitpläne"
}), _defineProperty(_CustomerInfo, "research_has_shown", {
  nl: "Uit onderzoek is gebleken dat men in meer dan 50% van de terugkerende opzoekingen op het internet naar openingsuren zoekt.",
  fr: "Des recherches ont montré que plus de 50% des recherches récurrentes sur Internet concernent les heures d'ouverture.",
  en: "Research has shown that more than 50% of the recurring searches on the internet are for opening hours.",
  de: "Die Forschung hat gezeigt, dass mehr als 50% der wiederkehrenden Suchanfragen auf dem Internet für Öffnungszeiten suchen."
}), _defineProperty(_CustomerInfo, "nobody_likes", {
  nl: "Niemand staat graag voor een gesloten deur! Wij hebben rekening gehouden met",
  fr: "Personne n'aime se tenir devant une porte fermée ! Nous avons pris en compte",
  en: "Nobody likes to stand in front of a closed door! We have taken into account",
  de: "Niemand mag sich vor einem geschlossenen Tür stehen! Wir haben berücksichtigt"
}), _defineProperty(_CustomerInfo, "all_possibilities", {
  nl: "alle mogelijkheden",
  fr: "toutes les possibilités",
  en: "all possibilities",
  de: "alle Möglichkeiten"
}), _defineProperty(_CustomerInfo, "so_that_everything_is_clear", {
  nl: "zodat alles voor de bezoeker heel duidelijk is.",
  fr: "afin que tout soit très clair pour le visiteur.",
  en: "so that everything is very clear for the visitor.",
  de: "damit alles für den Besucher sehr klar ist."
}), _defineProperty(_CustomerInfo, "do_you_have_diffrent_hours", {
  nl: "Heb je afhankelijk van seizoenen verschillende uren? Ben je marktkramer en sta je dagelijks op verschillende locaties en gedurende verschillende tijdstippen? Heb je tijdens openingstijden specifieke tijdslots waarbij je speciale acties aanbiedt?",
  fr: "Avez-vous des horaires différents selon les saisons ? Êtes-vous un vendeur de marché et êtes-vous quotidiennement à différents endroits et à différentes heures ? Avez-vous des créneaux horaires spécifiques pendant les heures d'ouverture où vous proposez des promotions spéciales ?",
  en: "Do you have different hours depending on the seasons? Are you a market vendor and are you daily at different locations and during different times? Do you have specific time slots during opening hours where you offer special promotions?",
  de: "Haben Sie unterschiedliche Stunden je nach Jahreszeiten? Sind Sie ein Marktproduzent und tragen Sie täglich an verschiedenen Standorten und während verschiedener Zeiten? Haben Sie spezielle Zeitslots während der Öffnungszeiten, an denen Sie besondere Angebote anbieten?"
}), _defineProperty(_CustomerInfo, "this_can_aal_be_made_clear", {
  nl: "Dit kan allemaal duidelijk gemaakt worden!",
  fr: "Cela peut être clair !",
  en: "This can all be made clear!",
  de: "Das kann alles klar gemacht werden!"
}), _defineProperty(_CustomerInfo, "simple_time_schedule", {
  nl: "Eenvoudig tijdschema",
  fr: "Horaires simplifiés",
  en: "Simple time schedule",
  de: "Einfacher Zeitplan"
}), _defineProperty(_CustomerInfo, "my_working_hours_regular", {
  nl: "Mijn werkuren zijn regelmatig en op sommige dagen ben ik gesloten.",
  fr: "Mes horaires de travail sont réguliers et certains jours je suis fermé.",
  en: "My working hours are regular and on some days I am closed.",
  de: "Meine Arbeitszeiten sind regelmäßig und an einigen Tagen bin ich geschlossen."
}), _defineProperty(_CustomerInfo, "ci_example", {
  nl: "VOORBEELD:",
  fr: "EXEMPLE :",
  en: "EXAMPLE:",
  de: "BEISPIEL:"
}), _defineProperty(_CustomerInfo, "monday_till_firday", {
  nl: "Maandag tot vrijdag: 08:00 - 12:30 & 13:00 - 17:00",
  fr: "Du lundi au vendredi : 08:00 - 12:30 & 13:00 - 17:00",
  en: "Monday till Friday: 08:00 - 12:30 & 13:00 - 17:00",
  de: "Montag bis Freitag: 08:00 - 12:30 & 13:00 - 17:00"
}), _defineProperty(_CustomerInfo, "closed_on_weekend", {
  nl: "Gesloten op zaterdag en zondag",
  fr: "Fermé le samedi et le dimanche",
  en: "Closed on Saturday and Sunday",
  de: "Geschlossen am Samstag und Sonntag"
}), _defineProperty(_CustomerInfo, "complicated_timetable", {
  nl: "Ingewikkeld tijdschema",
  fr: "Horaire compliqué",
  en: "Complicated timetable",
  de: "Komplizierter Zeitplan"
}), _defineProperty(_CustomerInfo, "my_working_hours_irregular", {
  nl: "Mijn werkuren zijn onregelmatig. De meeste werkdagen hebben verschillende uren.",
  fr: "Mes horaires de travail sont irréguliers. La plupart des jours ouvrables ont des horaires différents.",
  en: "My working hours are irregular. Most working days have different hours.",
  de: "Meine Arbeitszeiten sind unregelmäßig. Die meisten Arbeitstage haben unterschiedliche Stunden."
}), _defineProperty(_CustomerInfo, "monday_wednesday_friday", {
  nl: "Maandag, woensdag & vrijdag: 08:00 - 12:30",
  fr: "Lundi, mercredi et vendredi : 08:00 - 12:30",
  en: "Monday, Wednesday and Friday: 08:00 - 12:30",
  de: "Montag, Mittwoch und Freitag: 08:00 - 12:30"
}), _defineProperty(_CustomerInfo, "tuesday_thrusday", {
  nl: "Dinsdag & donderdag: 08:30 - 17:00",
  fr: "Mardi jeudi: 08:30 - 17:00",
  en: "Tuesday Thursday: 08:30 - 17:00",
  de: "Dienstag und Donnerstag: 08:30 - 17:00"
}), _defineProperty(_CustomerInfo, "type_of_opening_hours", {
  nl: "Type openingsuren:",
  fr: "Type d'heures d'ouverture :",
  en: "Type of opening hours:",
  de: "Art der Öffnungszeiten:"
}), _defineProperty(_CustomerInfo, "standard_hours", {
  nl: "Standaard uren:",
  fr: "Horaires standards :",
  en: "Standard hours:",
  de: "Standardstunden:"
}), _defineProperty(_CustomerInfo, "ci_monday", {
  nl: "Maandag",
  fr: "Lundi",
  en: "Monday",
  de: "Montag"
}), _defineProperty(_CustomerInfo, "ci_tuesday", {
  nl: "Dinsdag",
  fr: "Mardi",
  en: "Tuesday",
  de: "Dienstag"
}), _defineProperty(_CustomerInfo, "ci_wednesday", {
  nl: "Woensdag",
  fr: "Mercredi",
  en: "Wednesday",
  de: "Mittwoch"
}), _defineProperty(_CustomerInfo, "ci_thursday", {
  nl: "Donderdag",
  fr: "Jeudi",
  en: "Thursday",
  de: "Donnerstag"
}), _defineProperty(_CustomerInfo, "ci_friday", {
  nl: "Vrijdag",
  fr: "Vendredi",
  en: "Friday",
  de: "Freitag"
}), _defineProperty(_CustomerInfo, "ci_saturday", {
  nl: "Zaterdag",
  fr: "Samedi",
  en: "Saturday",
  de: "Samstag"
}), _defineProperty(_CustomerInfo, "ci_sunday", {
  nl: "Zondag",
  fr: "Dimanche",
  en: "Sunday",
  de: "Sonntag"
}), _defineProperty(_CustomerInfo, "ci_closed", {
  nl: "gesloten",
  fr: "fermé",
  en: "closed",
  de: "geschlossen"
}), _defineProperty(_CustomerInfo, "ci_divergent", {
  nl: "afwijkend",
  fr: "divergent",
  en: "divergent",
  de: "abweichend"
}), _defineProperty(_CustomerInfo, "want_set_period", {
  nl: "Wil je een periode instellen?",
  fr: "Voulez-vous définir une période ?",
  en: "Do you want to set a period?",
  de: "Möchten Sie eine Periode einrichten?"
}), _defineProperty(_CustomerInfo, "example_lowhigh_season", {
  nl: "bv. hoog- of laagseizoen",
  fr: "exemple: haute ou basse saison",
  en: "eg. high- or lowseizoen",
  de: "z.B. hohe- oder niederseitige Saison"
}), _defineProperty(_CustomerInfo, "ci_exceptions", {
  nl: "Uitzonderingen",
  fr: "Exceptions",
  en: "Exceptions",
  de: "Ausnahmen"
}), _defineProperty(_CustomerInfo, "ci_hollidays", {
  nl: "bv. feestdagen",
  fr: "exemple. jours fériés",
  en: "eg. hollidays",
  de: "z.B. Feiertage"
}), _defineProperty(_CustomerInfo, "ci_set_message", {
  nl: "Wil je een message instellen?",
  fr: "Voulez-vous définir un message ?",
  en: "Do you want to set a message?",
  de: "Möchten Sie eine Nachricht einrichten?"
}), _defineProperty(_CustomerInfo, "extra_info_about_timetable", {
  nl: "bv. extra info over tijdschema",
  fr: "exemple: des informations supplémentaires sur les horaires",
  en: "e.g. extra info about time schedule",
  de: "z.B. zusätzliche Informationen über den Zeitplan"
}), _defineProperty(_CustomerInfo, "enter_a_message", {
  nl: "Voer een bericht in",
  fr: "Complétez votre message. . .",
  en: "Enter a message",
  de: "Geben Sie eine Nachricht ein"
}), _defineProperty(_CustomerInfo, "other_date", {
  nl: "Andere datum",
  fr: "Date différente",
  en: "Other date",
  de: "Anderes Datum"
}), _defineProperty(_CustomerInfo, "select_1", {
  nl: "Selecteer 1",
  fr: "Sélectionnez 1",
  en: "Select 1",
  de: "Wählen Sie 1"
}), _defineProperty(_CustomerInfo, "all_holidays", {
  nl: "Alle feestdagen",
  fr: "Tous les jours fériés",
  en: "All hollidays",
  de: "Alle Feiertage"
}), _defineProperty(_CustomerInfo, "new_year", {
  nl: "Nieuwjaar",
  fr: "Nouvel An",
  en: "New Year",
  de: "Neujahr"
}), _defineProperty(_CustomerInfo, "pasen", {
  nl: "Pasen",
  fr: "Pâques",
  en: "Easter",
  de: "Ostern"
}), _defineProperty(_CustomerInfo, "easter_monday", {
  nl: "Paasmaandag",
  fr: "Lundi de Pâques",
  en: "Easter Monday",
  de: "Ostermontag"
}), _defineProperty(_CustomerInfo, "labour_day", {
  nl: "Dag van de Arbeid",
  fr: "Fête du Travail",
  en: "Labour day",
  de: "Tag der Arbeit"
}), _defineProperty(_CustomerInfo, "ascension_day", {
  nl: "Hemelvaart",
  fr: "Jour de l'Ascension",
  en: "Ascension day",
  de: "Auffahrt"
}), _defineProperty(_CustomerInfo, "whit_monday", {
  nl: "Pinkstermaandag",
  fr: "Lundi de Pentecôte",
  en: "Whit Monday",
  de: "Pfingstmontag"
}), _defineProperty(_CustomerInfo, "pentecost", {
  nl: "Pinksteren",
  fr: "Pentecôte",
  en: "Pentecost",
  de: "Pfingsten"
}), _defineProperty(_CustomerInfo, "nationial_holliday", {
  nl: "Nationale feestdag",
  fr: "Fête nationale",
  en: "Nationial Holliday",
  de: "Nationalfeiertag"
}), _defineProperty(_CustomerInfo, "assumption_of_mary", {
  nl: "O.L.V Hemelvaart",
  fr: "l'Assomption",
  en: "Assumption of Mary",
  de: "Mariä Himmelfahrt"
}), _defineProperty(_CustomerInfo, "all_saints_day", {
  nl: "Allerheiligen",
  fr: "Toussaint",
  en: "All saints day",
  de: "Allerheiligen"
}), _defineProperty(_CustomerInfo, "armistice_day", {
  nl: "Wapenstilstand",
  fr: "Armistice",
  en: "Armistice Day",
  de: "Waffenstillstand"
}), _defineProperty(_CustomerInfo, "christmas", {
  nl: "Kerstdag",
  fr: "Le jour de Noël",
  en: "Christmas",
  de: "Weihnachten"
}), _defineProperty(_CustomerInfo, "tow_more_points", {
  nl: "Nog twee puntjes..",
  fr: "Deux autres points..",
  en: "Two more points..",
  de: "Noch zwei Punkte.."
}), _defineProperty(_CustomerInfo, "three_more_points", {
  nl: "Nog drie puntjes...",
  fr: "Trois autres points...",
  en: "Three more points...",
  de: "Noch drei Punkte..."
}), _defineProperty(_CustomerInfo, "congratulation_completed", {
  nl: "Proficiat!... Je hebt nu alle stappen doorlopen en wij danken je hier nogmaals voor!",
  fr: "Félicitations !... Vous avez maintenant franchi toutes les étapes et nous vous en remercions encore !",
  en: "Congratulations!... You have now completed all the steps and we thank you again for this!",
  de: "Glückwunsch!... Sie haben nun alle Schritte abgeschlossen und wir danken Ihnen noch einmal für diese!"
}), _defineProperty(_CustomerInfo, "we_assume", {
  nl: "We gaan ervan uit dat je interesse hebt in een Business Page want deze krijg je het eerste jaar gratis (voorwaarde is wel dat je alles hebt aangevuld wat voor jouw onderneming van toepassing is).",
  fr: "Nous supposons que vous êtes intéressé par une Business Page car vous la recevrez gratuitement la première année (à condition que vous ayez rempli tout ce qui s'applique à votre entreprise).",
  en: "We assume that you are interested in a Business Page because you will receive it for free for the first year (on the condition that you have completed everything that applies to your company).",
  de: "Wir nehmen an, dass Sie sich für eine Business Page interessieren, weil Sie sie für die erste Jahresfreigabe (auf die Bedingung, dass Sie alles tun, was für Ihre Firma gelten sollte) erhalten werden."
}), _defineProperty(_CustomerInfo, "no_obbligation_to_renew", {
  nl: "Na afloop van het eerste jaar is er ook geen enkele verplichting om dit te hernieuwen.",
  fr: "Il n'y a aucune obligation de renouvellement après la première année.",
  en: "There is no obligation to renew after the first year.",
  de: "Es gibt keine Pflicht, nach der ersten Jahresfreigabe neu zu erwerben."
}), _defineProperty(_CustomerInfo, "interested_in_bp", {
  nl: "Ik heb intresse in mijn Business Page. (eerste jaar GRATIS - zie voorwaarden)",
  fr: "Je suis intéressé par ma Page Entreprise. (première année GRATUITE - voir conditions)",
  en: "I am interested in my Business Page. (first year FREE - see conditions)",
  de: "Ich bin interessiert an meiner Business Page. (erste Jahresfreigabe GRATIS - siehe Bedingungen)"
}), _defineProperty(_CustomerInfo, "show_bp", {
  nl: "Toon mijn persoonlijke Business Page",
  fr: "Afficher ma Page d'entreprise",
  en: "Show my personal Business Page",
  de: "Zeige meine persönliche Business Page"
}), _defineProperty(_CustomerInfo, "more_info", {
  nl: "MEER INFORMATIE",
  fr: "PLUS D'INFORMATION",
  en: "MORE INFORMATION",
  de: "MEHR INFORMATION"
}), _defineProperty(_CustomerInfo, "all_online_info", {
  nl: "Al jouw informatie wordt nu online getoond",
  fr: "Toutes vos informations sont maintenant affichées en ligne",
  en: "All your information is now shown online",
  de: "Alle Ihre Informationen werden nu online angezeigt"
}), _defineProperty(_CustomerInfo, "only_logo_address_and_phone_online_info", {
  nl: "Jouw logo met adres en telefoonnummers worden GRATIS weergegeven",
  fr: "Votre logo avec adresse et numéros de téléphone sera affiché GRATUITEMENT",
  en: "All your information is now shown online",
  de: "Alle Ihre Informationen werden nu online angezeigt"
}), _defineProperty(_CustomerInfo, "show_bp_button", {
  nl: "TOON HOE IK WORD WEERGEGEVEN",
  fr: "MONTRER COMMENT JE SUIS AFFICHÉ",
  en: "SHOW HOW I'M DISPLAYED",
  de: "ZEIGEN WIE ICH GEZEIGT WERDE"
}), _defineProperty(_CustomerInfo, "have_question", {
  nl: "Ik heb een vraag! Kan een raadgever mij vrijblijvend contacteren?",
  fr: "J'ai une question! Un conseiller peut-il me contacter sans engagement ?",
  en: "I have a question! Can a counselor contact me without obligation?",
  de: "Ich habe eine Frage! Kann ein Berater mich ohne Pflicht kontaktieren?"
}), _defineProperty(_CustomerInfo, "post_question", {
  nl: "Plaats jouw vraag hier...",
  fr: "Postez votre question ici...",
  en: "Post your question here",
  de: "Posten Sie Ihre Frage hier..."
}), _defineProperty(_CustomerInfo, "our_advisor", {
  nl: "Onze raadgever zal je zo spoedig mogelijk en vrijblijvend contacteren!",
  fr: "Notre conseiller vous contactera dans les plus brefs délais et sans engagement !",
  en: "Our advisor will contact you as soon as possible and without obligation!",
  de: "Unser Berater wird Sie so schnell wie möglich und ohne Pflicht kontaktieren!"
}), _defineProperty(_CustomerInfo, "earlier_you_decided", {
  nl: "Eerder besloot je om deel te nemen aan onze wedstrijd, fantastisch!",
  fr: "Tout à l'heure, vous avez décidé de participer à notre concours, fantastique !",
  en: "Earlier you decided to participate in our competition, fantastic!",
  de: "Früher haben Sie sich für unseren Wettbewerb entschieden, fantastisch!"
}), _defineProperty(_CustomerInfo, "please_confirm", {
  nl: 'Bevestig hieronder "DEELNAME WEDSTRIJD" om de datum en de tijd te registreren dat dit volledige formulier werd ingevuld.',
  fr: "Veuillez confirmer « PARTICIPATION AU CONCOURS » ci-dessous pour enregistrer la date et l'heure à laquelle ce formulaire complet a été rempli.",
  en: 'Please confirm "CONTEST PARTICIPATION" below to record the date and time this complete form was completed.',
  de: 'Bitte bestätigen Sie unten "ENTSCHEIDUNG AUF WETTBEWERB" um die Datum und die Uhrzeit zu erfassen, zu der dieses vollständige Formular ausgefüllt wurde.'
}), _defineProperty(_CustomerInfo, "as_stated_introduction", {
  nl: "Zoals vermeld in de introductie en het reglement wint elke 100ste onderneming die haar gegevens volledig heeft ingevuld automatsch een jaarabonnement ter waarde van € 1600.",
  fr: "Comme indiqué dans l'introduction et le règlement, chaque 100ème entreprise ayant renseigné ses coordonnées remporte automatiquement un abonnement annuel d'une valeur de 1600 €.",
  en: "As stated in the introduction and the regulations, every 100th company that has filled in its details automatically wins an annual subscription worth € 1600.",
  de: "Wie bereits in der Einführung und dem Verordnung angegeben, erhält jeder 100. Unternehmen, das seine Daten vollständig eingegeben hat, ein jährliches Abonnement für einen Wert von € 1600."
}), _defineProperty(_CustomerInfo, "by_clicking_on", {
  nl: "Door te klikken op onderstaande knop bevestig je alle gegevens m.b.t. jouw onderneming te hebben ingevuld.",
  fr: "En cliquant sur le bouton ci-dessous, vous confirmez avoir saisi toutes les informations concernant votre entreprise.",
  en: "By clicking on the button below you confirm that you have entered all information regarding your company.",
  de: "Durch Klicken auf die Schaltfläche unten bestätigen Sie, dass Sie alle Informationen über Ihre Firma eingegeben haben."
}), _defineProperty(_CustomerInfo, "participation_contest", {
  nl: "Deelname wedstrijd",
  fr: "Concours de participation",
  en: "Participation contest",
  de: "Wettbewerb Teilnahme"
}), _defineProperty(_CustomerInfo, "congrats_done", {
  nl: "Proficiat, je bent klaar en krijgt jouw Business Page 1 jaar",
  fr: "Félicitations, vous avez terminé et obtenez votre page d'entreprise 1 an",
  en: "Congratulations, you're done and get your Business Page 1 year",
  de: "Glückwunsch, Sie sind fertig und erhalten Ihre Geschäft Seite 1 Jahr"
}), _defineProperty(_CustomerInfo, "thank_you_very_much", {
  nl: "We willen je vanharte bedanken!",
  fr: "Nous tenons à vous remercier chaleureusement !",
  en: "We would like to thank you very much!",
  de: "Wir möchten Ihnen sehr viel Danke!"
}), _defineProperty(_CustomerInfo, "we_appreciate_efforts", {
  nl: "Wij waarderen je inzet en hierdoor wordt jouw onderneminglokaal zichtbaarder.",
  fr: "Nous apprécions vos efforts et cela rend votre entrepriseplus visible localement.",
  en: "We appreciate your efforts and this makes your companymore visible locally.",
  de: "Wir bedanken Ihre Arbeit und machen Ihre Firma lokal sichtbarer."
}), _defineProperty(_CustomerInfo, "because_the_internet", {
  nl: "Omdat het internet steeds evolueert engageren wij ons om hierin mee te groeien.",
  fr: "Parce qu'Internet évolue constamment, nous nous engageons à grandir avec lui.",
  en: "Because the internet is constantly evolving, we are committed to growing with it.",
  de: "Da Internet ständig evolutioniert, sind wir mit ihm eng verbunden."
}), _defineProperty(_CustomerInfo, "we_are_not_yet_finished", {
  nl: "Wij zijn nog niet volledig klaar met het realiseren van onze eigen ideeën en staan ook open voor jouw eventuele inbreng. Daag jij ons uit?",
  fr: "Nous n'avons pas encore complètement fini de concrétiser nos propres idées et sommes également ouverts à toute contribution que vous pourriez avoir. Allez-vous nous défier ?",
  en: "We are not yet completely finished with realizing our own ideas and are also open to any input you may have. Will you challenge us?",
  de: "Wir sind noch nicht vollständig mit der Realisierung unserer eigenen Ideen fertig und sind auch offen für jede Eingabe, die Sie haben könnten. Willst du uns herausfordern?"
}), _defineProperty(_CustomerInfo, "click_next_button", {
  nl: "Klik op de volgende knop om jouw volledige publicatie te bekijken.",
  fr: "Cliquez sur le bouton suivant pour afficher votre publication complète.",
  en: "Click on the next button to view your full publication.",
  de: "Klicken Sie auf die nächste Schaltfläche, um Ihre vollständige Veröffentlichung anzuzeigen."
}), _defineProperty(_CustomerInfo, "show_bp_finish", {
  nl: "TOON MIJN BUSINESS PAGE",
  fr: "AFFICHER MA PAGE D'ENTREPRISE",
  en: "SHOW MY BUSINESS PAGE",
  de: "ZEIGE MICHRE BUSINESS PAGE"
}), _defineProperty(_CustomerInfo, "you_have_just_reached", {
  nl: "Je hebt net de allerlaatste stap bereikt en wij gaan ervan uit dat je dit initiatief graag deelt.",
  fr: "Vous venez d'atteindre la toute dernière étape et nous supposons que vous êtes heureux de partager cette initiative.",
  en: "You have just reached the very last step and we assume that you are happy to share this initiative.",
  de: "Sie haben gerade die letzte Schritt erreicht und wir nehmen an, dass Sie diese Initiative freundlich teilen."
}), _defineProperty(_CustomerInfo, "will_you_also_show", {
  nl: "Toon je dit dan ook even op de sociale media van jouw keuze?",
  fr: "Allez-vous également le montrer sur les réseaux sociaux de votre choix ?",
  en: "Will you also show this on the social media of your choice?",
  de: "Zeigen Sie dies auch auf den sozialen Medien Ihrer Wahl an?"
}), _defineProperty(_CustomerInfo, "you_can_also_send", {
  nl: "Je kan ook rechtstreeks collega ondernemers een uitnodiging sturen die ook hun gegeven kunnen optimaliseren.",
  fr: "Vous pouvez également envoyer une invitation directement à d'autres entrepreneurs qui peuvent également optimiser leurs données.",
  en: "You can also send an invitation directly to fellow entrepreneurs who can also optimize their data.",
  de: "Sie können auch eine Einladung direkt an Kollegen senden, die auch ihre Daten optimieren können."
}), _defineProperty(_CustomerInfo, "they_too_will_enjoy", {
  nl: "Ook zij zullen genieten van de voordelen die jij hebt verkregen.",
  fr: "Eux aussi profiteront des avantages que vous avez obtenus.",
  en: "They too will enjoy the benefits you have obtained.",
  de: "Sie genießen auch die Vorteile, die Sie erhalten haben."
}), _defineProperty(_CustomerInfo, "add_an_email_address", {
  nl: "Voeg een email adres toe van een collega ondernemer (optioneel)",
  fr: "Ajouter une adresse e-mail d'un collègue entrepreneur (facultatif)",
  en: "Add an email address of a colleague entrepreneur (optional)",
  de: "Fügen Sie eine E-Mail-Adresse eines Kollegen ein (optional)"
}), _defineProperty(_CustomerInfo, "press_the_plus_sign", {
  nl: "Druk op het “+” teken na de invoer hierboven van elk geldig e-mailadres.",
  fr: 'Appuyez sur le signe "+" après avoir saisi chaque adresse e-mail valide ci-dessus.',
  en: "Press the “+” sign after entering each valid email address above.",
  de: "Drücken Sie den „+“-Zeichen, nachdem Sie jedes gültige E-Mail-Adresse oben eingegeben haben."
}), _defineProperty(_CustomerInfo, "this_way_multiple_email", {
  nl: "Op deze manier kunnen meerdere e-mail adressen worden ingevoerd.",
  fr: 'Plusieurs adresses e-mail peuvent être saisies de cette manière.',
  en: "This way multiple e-mail addresses can be entered.",
  de: "Auf diese Weise können mehrere E-Mail-Adressen eingegeben werden."
}), _defineProperty(_CustomerInfo, "general_info", {
  nl: "Algemeene informatie",
  fr: 'Renseignements généraux',
  en: "General info",
  de: "Allgemeine Informationen"
}), _defineProperty(_CustomerInfo, "annual_publication", {
  nl: "JAARLIJKSE PUBLICATIE ONDERNEMERS- EN SHOPPINGNETWERK",
  fr: 'PUBLICATION(S) ANNUELLE RÉSEAU SHOPPING- ET ENTREPRENEURS',
  en: "ANNUAL PUBLICATION ENTREPRENEURS AND SHOPPING NETWORK",
  de: "JÄHRLICHE VERÖFFENTLICHUNG EIGENT- UND SHOPPINGNETWORK"
}), _defineProperty(_CustomerInfo, "contact_expires_after", {
  nl: "( contract loopt af na 365 dagen )",
  fr: "( contrat expire après 365 jours )",
  en: '( contract expires after 365 days )',
  de: '( Vertrag läuft nach 365 Tagen ab )'
}), _defineProperty(_CustomerInfo, "cancellation_of_the_osn_business_page", {
  nl: "idBForge BV onderstreept het belang van een goede samenwerking met haar klanten. Partijen communiceren hiervoor via WhatsApp tenzij schriftelijk anders bepaald. <b>Opgelet!</b> Bij overeenkomsten die worden afgesloten voor een termijn van 365 dagen is idBForge verplicht om de hernieuwing bij haar partners voor de domeinnaam (DNS Belgium) en de hostingruimte tijdig te bevestigen. Om deze reden zal er naar het facturatie email adres, dat in deze overeenkomst wordt opgenomen, 30 dagen voor afloop van de overeenkomst een nieuwe periode van 365 dagen worden aangekondigd d.m.v. een nieuwe factuur die op de vervaldag definitief wordt. De ontvangstbevestiging zal mee bewaard worden in het dossier.",
  fr: "idBForge SRL souligne l’importance d’une bonne coopération avec ses clients. Les parties communiquent à cet effet via WhatsApp, sauf indication contraire par écrit. <b>Attention!</b> Pour les contrats conclus pour une durée de 365 jours, idBForge est tenu de confirmer dans les délais le renouvellement avec ses partenaires du nom de domaine (DNS Belgique) et de l'espace d'hébergement. Pour cette raison, un nouveau délai de 365 jours sera annoncé à l'adresse email de facturation incluse dans le présent contrat 30 jours avant la fin du contrat au moyen de : une nouvelle facture qui devient définitive à la date d'échéance. L’accusé de réception sera conservé au dossier.",
  en: "Cancellation of the OSN Business Page can be communicated at any time by e-mail or regular letter. A confirmation of receipt will be sent automatically by return. Attention! To keep the OSN Business Pages up to date, we work with external companies, so any cancellation must be done 30 days before the end of the agreement. idBForge BV will send a timely reminder with automatic confirmation of receipt to the e-mail address included in the agreement so that the entrepreneur can cancel this in a timely manner if desired.",
  de: "Die Kündigung der OSN Business Page kann jederzeit per E-Mail oder regulärem Brief mitgeteilt werden. Eine Empfangsbestätigung wird automatisch zurückgesendet. <b>Achtung!</b> Um die OSN Business Pages aktuell zu halten, arbeiten wir mit externen Unternehmen zusammen, daher muss eine Kündigung 30 Tage vor Ablauf des Vertrags erfolgen. idBForge BV wird rechtzeitig eine Erinnerung mit automatischer Empfangsbestätigung an die im Vertrag angegebene E-Mail-Adresse senden, damit der Unternehmer diese bei Bedarf rechtzeitig kündigen kann."
}), _defineProperty(_CustomerInfo, "supermarket_type", {
  nl: "Type supermarkt",
  fr: 'Type de supermarché',
  en: "Supermarket type",
  de: "Supermarkt-Typ"
}), _defineProperty(_CustomerInfo, "start", {
  nl: "Aanvang",
  fr: 'Commencement',
  en: "Start",
  de: "Start"
}), _defineProperty(_CustomerInfo, "end", {
  nl: "Einde",
  fr: 'Fin',
  en: "End",
  de: "Ende"
}), _defineProperty(_CustomerInfo, "payment", {
  nl: "Betaling",
  fr: 'Paiement',
  en: "Payment",
  de: "Zahlung"
}), _defineProperty(_CustomerInfo, "publication", {
  nl: "Publicatie",
  fr: 'Publication',
  en: "Publication",
  de: "Veröffentlichung"
}), _defineProperty(_CustomerInfo, "billing_email", {
  nl: "E-mail facturatie",
  fr: 'E-mail de facturation',
  en: "Billing e-mail",
  de: "Rechnungs-E-Mail"
}), _defineProperty(_CustomerInfo, "packs_and_products", {
  nl: "Packs & Producten",
  fr: 'Packs & Produits',
  en: "Packs & Products",
  de: "Packs & Produkte"
}), _defineProperty(_CustomerInfo, "in_which_region_can_customers_find_you", {
  nl: "In welke regio mogen klanten jou vinden?",
  fr: 'Dans quelle région les clients peuvent-ils vous trouver ?',
  en: "In which region can customers find you?",
  de: "In welcher Region können Kunden Ihnen finden?"
}), _defineProperty(_CustomerInfo, "search_municipality_ci", {
  nl: "Zoek gemeente",
  fr: 'Rechercher une commune',
  en: "Search_municipality",
  de: "Suche Gemeinde"
}), _defineProperty(_CustomerInfo, "packs", {
  nl: "Packs",
  fr: 'Packs',
  en: "Packs",
  de: "Packs"
}), _defineProperty(_CustomerInfo, "products", {
  nl: "Producten",
  fr: 'Produits',
  en: "Products",
  de: "Produkte"
}), _defineProperty(_CustomerInfo, "wallets", {
  nl: "Wallets",
  fr: 'Wallets',
  en: "Wallets",
  de: "Wallets"
}), _defineProperty(_CustomerInfo, "value", {
  nl: "Waarde",
  fr: 'Valeur',
  en: "Value",
  de: "Wert"
}), _defineProperty(_CustomerInfo, "delete", {
  nl: "Verwijderen",
  fr: 'Supprimer',
  en: "Delete",
  de: "Löschen"
}), _defineProperty(_CustomerInfo, "meer_toevoegen", {
  nl: "Meer toevoegen",
  fr: 'Ajouter plus',
  en: "Add more",
  de: "Mehr hinzufügen"
}), _defineProperty(_CustomerInfo, "agreement", {
  nl: "Overeenkomst",
  fr: 'Accord',
  en: "Agreement",
  de: "Vertrag"
}), _defineProperty(_CustomerInfo, "digitally_created_and_approved_by_both_parties", {
  nl: "DIGITAAL OPGEMAAKT EN GOEDGEKEURD DOOR BEIDE PARTIJEN.<br/> OVEREENKOMST OVERGEMAAKT NAAR HET FACTURATIE E-MAILADRES VERMELD<br/> IN DEZE OVEREENKOMST EN NAAR idBForge BV",
  fr: "ÉTABLIS NUMÉRIQUEMENT ET APPROUVÉ PAR LES DEUX PARTIES.<br/> CONTRAT TRANSFÉRÉ À L'ADRESSE DE MESSAGERIE POUR FACTURATION<br/> MENTIONNÉ DANS CE CONTRAT ET A IDENTITYBUILDING SRL.",
  en: "DIGITALLY CREATED AND APPROVED BY BOTH PARTIES. AGREEMENT SENT TO THE EMAIL ADDRESS MENTIONED IN THIS AGREEMENT AND TO idBForge BV.",
  de: "DIGITAL ERSTELLT UND GEGEN ANTWORT GESTELLT VON BOTH PARTIES. VEREIN SENDEN AN DIE EMAIL ADRESSE, DIE IN DIESEM VEREIN ERWÄHNT UND AN idBForge BV."
}), _defineProperty(_CustomerInfo, "at", {
  nl: "Te",
  fr: "À",
  en: 'At',
  de: 'An'
}), _defineProperty(_CustomerInfo, "on", {
  nl: "Op",
  fr: 'Sur',
  en: "On",
  de: 'Auf'
}), _defineProperty(_CustomerInfo, "before_signing_this_agreement", {
  nl: "De klant erkent, vóór de ondertekening van deze overeenkomst, kennis te hebben genomen van de algemene voorwaarden* (inclusief de geldende en geparafeerde extra promotievoorwaarden onder punt 12) en de tarieven van idBForge BV te hebben aanvaard zonder voorbehoud. Voor de rechtspersonen moet de verbintenis onderschreven worden door de persoon (personen) die gemachtigd is (zijn) namens de rechtspersoon op te treden. Indien publicatiemateriaal niet werd overgemaakt binnen de 5 dagen wordt automatisch de factuur overgemaakt.",
  fr: "Le client souligne avoir pris connaissance des conditions générales en signant ce contrat. *(Inclus des conditions de promotions à sous point 12) et les tarifs de idBForge SRL et avoir accepté ceux-là sans réserve. Pour les personnes de droits le contrat doit être souscrit par la (les) personne(s) autorisé(e)s à signer au nom de l'organisme ou la personnalité morale. En cas de manque de transmission du matériel de publication dans les 5 jours la facture sera automatiquement transmise.",
  en: "<b>Before</b> signing this agreement, the customer acknowledges that he has taken note of the general terms and conditions * (including the applicable and initialed promotional conditions on the reverse side) and that he has accepted the rates of idBForge BV without reservation. For legal entities, the commitment must be signed by the person(s) authorized to act on behalf of the legal entity. If publication material has not been transferred within 5 days, the invoice will be transferred automatically.",
  de: "<b>Vor</b> der Unterzeichnung dieser Vereinbarung bestätigt der Kunde, dass er die Allgemeinen Geschäftsbedingungen* (einschließlich der anwendbaren und initialierten Sonderkonditionen unter Punkt 12) zur Kenntnis genommen und die Preise von idBForge BV vorbehaltlos akzeptiert hat. Für juristische Personen muss die Verpflichtung von der/dem vertretungsberechtigten Person(en) unterzeichnet werden. Falls das Veröffentlichungsmaterial nicht innerhalb von 5 Tagen übermittelt wird, wird die Rechnung automatisch ausgestellt."
}), _defineProperty(_CustomerInfo, "signature_of_the_customer", {
  nl: "Handtekening van de klant",
  fr: 'Signature du client',
  en: "Signature of the customer",
  de: "Unterschrift des Kunden"
}), _defineProperty(_CustomerInfo, "incl_read_and_aaproved", {
  nl: "(incl. gelezen en goedgekeurd):",
  fr: '(y compris lu et approuvé) :',
  en: "(incl. read and approved):",
  de: "(eingeschlossen: gelesen und genehmigt):"
}), _defineProperty(_CustomerInfo, "position_and_name_of_the_signatory", {
  nl: "Functie en naam van de ondertekenaar",
  fr: 'Fonction et nom du signataire',
  en: "Position and name of the signatory",
  de: "Position und Name des Unterschreibers"
}), _defineProperty(_CustomerInfo, "fully_written", {
  nl: "(voluit geschreven):",
  fr: '(entièrement écrit) :',
  en: "(fully written):",
  de: "(vollständig geschrieben):"
}), _defineProperty(_CustomerInfo, "this_agreement_only_has_value_and_binds_identityBuilding", {
  nl: "Onderhavige overeenkomst heeft slechts waarde en verbindt idBForge BV, voor zover de erin voorkomende vermeldingen juist en volledig zijn. Door het ondertekenen van deze overeenkomst geeft de klant de uitdrukkelijke toestemming aan ieder persoon om aan idBForge BV de nodige inlichtingen te verstrekken die deze laatste nodig heeft om zijn financiële kredietwaardigheid na te gaan.",
  fr: "Ce contrat a une valeur et uni idBForge SRL uniquement si les éléments complets sont corrects et juste. En signant ce contrat le client donne la permission à toute personne de donner toutes informations nécessaires à idBForge SRL dont ils ont besoin pour le contrôle de la solvabilité.",
  en: "This agreement only has value and binds idBForge BV to the extent that the statements contained therein are correct and complete. By signing this agreement, the Saturday customer gives explicit permission to any person to provide idBForge BV with the necessary information Sunday that the latter needs to check his financial creditworthiness.",
  de: "Diese Vereinbarung hat nur Wert und bindet idBForge BV auf die Bedingung, dass die in den Absätzen enthaltenen Aussagen korrekt und vollständig sind. Durch die Unterzeichnung dieser Vereinbarung erteilt der Sonntag-Kunde die ausdrückliche Erlaubnis, jeder Person, um mit idBForge BV die notwendigen Informationen zu liefern, die der Kunde benötigt, um seine Finanzkreditwortüchtigkeit zu überprüfen."
}), _defineProperty(_CustomerInfo, "inquire_about_the_exclusive_benefits_of_a_OnePage", {
  nl: "Informeer naar de exclusieve voordelen van een OnePage!",
  fr: "Renseignez-vous sur les avantages exclusifs d'une OnePage !",
  en: "Inquire about the exclusive benefits of a OnePage!",
  de: "Fragen Sie sich auf die exklusiven Vorteile einer OnePage!"
}), _defineProperty(_CustomerInfo, "logo_for_free_in_the_companys_municipality_without_commitment", {
  nl: "Logo gratis in de gemeente van de onderneming zonder verbintenis",
  fr: "Logo gratuit dans la commune de l'entreprise sans engagement",
  en: "Logo for free in the company's municipality without commitment",
  de: "Logo für frei in der Gemeinde der Firma ohne Verpflichtung"
}), _defineProperty(_CustomerInfo, "general_terms_and_conditions_apply", {
  nl: "Algemene voorwaarden van toepassing - Te consulteren op:",
  fr: "Conditions générales applicables - Consultables à l'adresse suivante :",
  en: 'General terms and conditions apply - Can be consulted at:',
  de: 'Allgemeine Geschäftsbedingungen gelten - Sie können unter folgendem Link nachsehen:'
}), _defineProperty(_CustomerInfo, "our_general_terms_and_conditions_always_gets_sent", {
  nl: "Onze algemene voorwaarden worden altijd meegestuurd met elke overeenkomst en ook met de factuur die met bpost of per e-mail wordt verzonden! Ook te lezen of te downloaden op: <a href='https://www.o-sn.be/identitybuilding/algemenevoorwaarden.pdf' target='_blank'>www.o-sn.be/idbforge/algemenevoorwaarden.pdf</a> <br />In geval van discrepanties - tussen de algemene voorwaarden die op de factuur vermeld staan of per e-mail verzonden - en de meest recente versie zoals gepubliceerd op onze website, prevaleren de voorwaarden op de website.",
  fr: "Nos conditions générales sont toujours jointes à chaque accord ainsi qu'à la facture envoyée par bpost ou par e-mail en cours d'envoi ! Peut également être lu ou téléchargé sur : <a href='https://www.o-sn.be/identitybuilding/conditionsgenerales.pdf' target='_blank'>www.o-sn.be/idbforge/conditionsgenerales.pdf</a> <br />En cas de divergences - entre les conditions générales mentionnées sur la facture ou envoyées par e-mail - et la version la plus récente publiée sur notre site internet, les conditions disponibles sur le site prévalent.",
  en: "Our general terms and conditions are always attached to each agreement as well as to the invoice sent by bpost or by email while being sent! They can also be read or downloaded at: <a href='https://www.o-sn.be/identitybuilding/conditionsgenerales.pdf' target='_blank'>www.o-sn.be/idbforge/conditionsgenerales.pdf</a> <br />In case of discrepancies - between the general terms and conditions mentioned on the invoice or sent by email - and the most recent version published on our website, the terms available on the website shall prevail.",
  de: "Unsere allgemeinen Geschäftsbedingungen werden immer mit jeder Vereinbarung verbunden, sowie mit der Rechnung, die per bpost oder per E-Mail gesendet wird, und werden auch immer unter folgendem Link verfügbar sein: <a href='https://www.o-sn.be/identitybuilding/conditionsgenerales.pdf' target='_blank'>www.o-sn.be/idbforge/conditionsgenerales.pdf</a> <br />Falls Unterschiede auftreten - zwischen den allgemeinen Geschäftsbedingungen, die auf der Rechnung oder per E-Mail erwähnt werden - und der aktuellsten Version, die auf unserer Website veröffentlicht wird, gelten die Bedingungen auf der Website."
}), _defineProperty(_CustomerInfo, "conditions", {
  nl: "Voorwaarden",
  fr: 'Conditions',
  en: "Conditions",
  de: "Bedingungen"
}), _defineProperty(_CustomerInfo, "known_promotion_and_additional_conditions_aply", {
  nl: "* GEKENDE PROMOTIE- EN BIJKOMENDE VOORWAARDEN GELDEND VOOR ALLE ZELFSTANDIGE ONDERNEMERS",
  fr: "* CONDITIONS PROMOTIONNELLES ET SUPPLÉMENTAIRES CONNUES, APPLICABLES À TOUS LES ENTREPRENEURS INDÉPENDANTS",
  en: "* KNOWN PROMOTION AND ADDITIONAL CONDITIONS APPLY TO ALL INDEPENDENT ENTREPRENEURS",
  de: "* BESCHRÄNKT SIND KNOWN PROMOTION UND ZUSÄTZLICHE BEDINGUNEN FÜR ALLE INDEPENDENT-EINTRITTEBER"
}), _defineProperty(_CustomerInfo, "the_entrepreneur_was_informed_about_the_options_and_promotions_we_offer", {
  nl: "<b>1.</b> DE ONDERNEMER werd in kennis gesteld over de mogelijkheden en acties die wij aanbieden. Eventuele huis-aan- huis folders, aanvullende promoties catalogi en magazines die ons digitaal aangeleverd worden, zullen steeds tijdig online staan. idBForge BV zal een boete van € 25,00 per vaststelling verschuldigd zijn indien hiervan wordt afgeweken*! (*op voorwaarde dat het materiaal ons tijdig werd overgemaakt door de ONDERNEMER)",
  fr: "<b>1.</b> L'ENTREPRENEUR a été informé des options et promotions que nous proposons. Toutes les dépliants de porte-à-porte, promotions supplémentaires, catalogues et magazines qui nous sont fournis sous forme numérique seront toujours en ligne en temps opportun. idBForge SRL sera redevable d’une amende de 25,00 € par détermination en cas d’écart*! (*à condition que le matériel nous ait été transféré à temps par l’ENTREPRENEUR).",
  en: "<b>1.</b> THE ENTREPRENEUR was informed about the options and promotions we offer. Any door-to-door brochures, additional promotions, catalogs and magazines that are delivered to us digitally will always be online in a timely manner. <b>idBForge BV</b> will owe a fine of € 25.00 per determination if this is deviated from*! (*provided that the material was transferred to us in time by the ENTREPRENEUR)",
  de: "<b>1.</b> DER UNTERNEHMER wurde über die von uns angebotenen Optionen und Aktionen informiert. Alle digital bereitgestellten Haus-zu-Haus-Flyer, zusätzlichen Promotionen, Kataloge und Magazine werden stets rechtzeitig online verfügbar sein. <b>idBForge BV</b> schuldet eine Strafe von 25,00 € pro Feststellung, falls hiervon abgewichen wird*! (*vorausgesetzt, das Material wurde uns rechtzeitig vom UNTERNEHMER übermittelt)."
}), _defineProperty(_CustomerInfo, "promotional_terms_and_conditions_are_valid_for_the_first_year", {
  nl: "<b>2.</b> Promotievoorwaarden zijn uitsluitend geldig voor zover facturen op de vervaldag betaald zijn! Bij niet betaling op de vervaldag aanvaardt de klant de normale tariefprijs waarvoor een aanvullende factuur zal overgemaakt worden. De normale tariefprijs wordt altijd vermeld op de oorspronkelijke factuur. Om de domeinnaam (URL) van uw persoonlijke website te vrijwaren, verzenden wij 30 dagen voor afloop van de vorige periode uw nieuwe factuur. Op de vervaldag van uw factuur wordt deze definitief.",
  fr: "<b>2.</b> Les conditions promotionnelles ne sont valables que si les factures sont payées à la date d'échéance ! En cas de non-paiement à la date d'échéance, le client accepte le prix du tarif normal pour lequel une facture supplémentaire sera envoyée. Le prix normal du tarif est toujours mentionné sur la facture originale. Pour sauvegarder le nom de domaine (URL) de votre site web personnel, nous vous enverrons votre nouvelle facture 30 jours avant la fin de la période précédente. À la date d'échéance, votre facture devient définitive.",
  en: "<b>2.</b> Promotional terms and conditions are valid for the first year and provided invoices are paid by the due date! If payment is not made on the due date, the customer accepts the normal rate price for which an additional invoice will be sent. To safeguard the domain name (URL) of your personal website, we will send your new invoice 14 days before the end of the year. It becomes final on the due date of your invoice.",
  de: "<b>2.</b> Die Aktionsbedingungen gelten ausschließlich für das erste Jahr und nur, wenn Rechnungen bis zum Fälligkeitsdatum bezahlt werden! Bei Nichtzahlung akzeptiert der Kunde den normalen Tarifpreis, für den eine zusätzliche Rechnung ausgestellt wird. Um den Domainnamen (URL) Ihrer persönlichen Website zu sichern, senden wir 14 Tage vor Ablauf der vorherigen Periode Ihre neue Rechnung. Diese wird am Fälligkeitsdatum endgültig."
}), _defineProperty(_CustomerInfo, "identitybuilding_undertakes_to_fulfill_administrative_and_marketing_tasks", {
  nl: "<b>3.</b> idBForge BV verbindt zich om administratieve- en marketingtaken te vervullen die eveneens noodzakelijk zijn om de ranking van uw website ook in Google te optimaliseren! Om dit mogelijk te maken verleent u alle toegangs- en of beheerdersrechten voor bestaande en door onze diensten aan te maken of te beheren Facebook, Instagram en Google Business pagina’s.<br/><br/> Elke ondernemer is eigenaar van haar bedrijfsvermelding bij Google en heeft het recht om deze te claimen indien blijkt dat derden de eigendomsrechten in hun bezit hebben. Met deze overeenkomst verkrijgt idBForge BV van de gecontracteerde ondernemer de toestemming om de bedrijfspagina in naam van de ondernemer te claimen. idBForge BV wil met deze maatregel vermijden dat derden aanpassingen uitvoeren die niet overeenkomen met de afspraken uit deze overeenkomst.<br/><br/> idBForge BV past in het kader van dit akkoord een aantal gunsttarieven toe op de OSN business pagina die alle info weergeeft over de onderneming waaronder ook de openingsuren. In de Google bedrijfspagina zal via de link “Website” de OSN business pagina weergegeven worden.<br/><br/> Zolang idBForge BV het beheer van de Google bedrijfspagina behoudt wordt er eveneens een extra voordeel toegepast op een aantal producten. Van zodra idBForge BV publicatiemateriaal verkrijgt zal zij deze online verwerken en communiceren naar de geregistreerde gebruikers. Het is de bedoeling om al deze online diensten in 1 pakket aan te bieden zodat wij onze klanten/ondernemers volledig kunnen ontzorgen van de noden voor online marketing.",
  fr: "<b>3.</b> idBForge SRL s'engage à effectuer des tâches administratives et de marketing qui sont également nécessaires pour optimiser le classement de votre site web dans Google aussi ! Pour rendre cela possible, vous accordez tous les droits d'accès et/ou d'administration pour les pages Facebook, Instagram et Google Business existantes et par nos services à créer ou à gérer.<br/><br/> Chaque entrepreneur est propriétaire de sa fiche d'entreprise auprès de Google et a le droit de la revendiquer s'il apparaît que des tiers en détiennent les droits de propriété. Par cet accord, idBForge BV obtient de l'entrepreneur sous contrat l'autorisation de revendiquer la page d'entreprise au nom de l'entrepreneur. idBForge BV veut utiliser cette mesure pour éviter que des tiers ne fassent des ajustements qui ne sont pas conformes aux accords de cet accord.<br/><br/> idBForge SRL appliquera, dans le cadre de cet accord, un certain nombre de favoris à la page commerciale de l'OSN qui affiche toutes les informations sur l'entreprise, y compris les heures d'ouverture. Dans la page Google business, la page OSN business sera affichée via le lien 'Site Web'.<br/><br/> Tant qu'idBForge BV conserve la gestion de la page d'entreprise Google, un avantage supplémentaire sera également appliqué à un certain nombre de produits. Dès qu'idBForge SRL obtient du matériel de publication, il le traite en ligne et le communique aux utilisateurs enregistrés. L'objectif est d'offrir tous ces services en ligne dans un seul paquet afin de soulager complètement nos clients/entrepreneurs de leurs besoins en matière de marketing en ligne.",
  en: "<b>3.</b> <b>idBForge BV</b> undertakes to fulfill administrative and marketing tasks that are necessary to optimize the ranking of your website in Google! To make this possible, you grant all access and/or administrative rights to existing Facebook, Instagram and Google Business pages to be created or managed by our services. Every merchant owns their Google business listing and has the right to claim it if third parties are found to have ownership rights. With this agreement, <b>idBForge BV</b> obtains permission from the contracted entrepreneur to claim the company page in the name of the merchant/signatory. With this measure, <b>idBForge BV</b> wants to prevent third parties from making adjustments that do not correspond to the agreements in this agreement. In the context of this agreement, <b>idBForge BV</b> applies a favorable rate <b>on the OSN business page</b> that displays all information about the company. including the opening hours. In the Google business page, the OSN business page will be displayed via the 'Website' link. We also offer a <b>50%</b> discount on the <b>personal website</b> and the extra <b>photo book</b> as long as <b>idBForge BV</b> retains management of the Google company page. As soon as <b>idBForge BV</b> obtains publication material, it will process this online and communicate it to the registered users. The intention is to offer all these online services in 1 package without any work on your part as an entrepreneur!",
  de: "<b>3.</b> <b>idBForge BV</b> verpflichtet sich, administrative und marketingbezogene Aufgaben zu übernehmen, die notwendig sind, um das Ranking Ihrer Website bei Google zu optimieren! Um dies zu ermöglichen, gewähren Sie alle Zugangs- und/oder Administratorrechte für bestehende und von unseren Diensten zu erstellende oder zu verwaltende Facebook-, Instagram- und Google Business-Seiten.<br/><br/> Jeder Unternehmer besitzt seinen Google-Unternehmenseintrag und hat das Recht, diesen zu beanspruchen, falls Dritte Eigentumsrechte besitzen. Mit dieser Vereinbarung erhält <b>idBForge BV</b> die Erlaubnis des beauftragten Unternehmers, die Unternehmensseite im Namen des Unternehmers zu beanspruchen. Diese Maßnahme soll verhindern, dass Dritte Änderungen vornehmen, die nicht den Vereinbarungen entsprechen.<br/><br/> Im Rahmen dieser Vereinbarung wendet <b>idBForge BV</b> günstige Konditionen auf die OSN-Geschäftsseite an, die alle Informationen über das Unternehmen einschließlich der Öffnungszeiten enthält. Auf der Google-Unternehmensseite wird die OSN-Geschäftsseite über den Link „Website“ angezeigt.<br/><br/> Solange <b>idBForge BV</b> die Verwaltung der Google-Unternehmensseite behält, wird auch ein zusätzlicher Vorteil auf bestimmte Produkte angewendet. Sobald <b>idBForge BV</b> Veröffentlichungsmaterial erhält, wird dieses online verarbeitet und an die registrierten Nutzer kommuniziert. Ziel ist es, alle diese Online-Dienste in einem Paket anzubieten, um unsere Kunden/Unternehmer vollständig von ihren Online-Marketing-Bedürfnissen zu entlasten."
}), _defineProperty(_CustomerInfo, "identityBuilding_bv_will_maintain_regular_contact_with_entrepreneurs", {
  nl: "<b>4.</b> idBForge BV onderhoudt op regelmatige basis contacten met ondernemers die nieuwe ideeën aanbrengen. Hierbij onderzoeken wij in hoeverre er extra diensten en voordelen kunnen toegepast worden die een meerwaarde kunnen zijn. Het is de bedoeling om na het verloop van het eerste jaar een optimale samenwerking aan te tonen en deze voor de toekomst te bevestigen.",
  fr: "<b>4.</b> idBForge SRL entretient des contacts réguliers avec les entrepreneurs qui apportent de nouvelles idées. Nous examinons ici dans quelle mesure il est possible d'appliquer des services et des avantages supplémentaires susceptibles d'apporter une valeur ajoutée. L'objectif est de démontrer une collaboration optimale après la première année et de la confirmer pour l'avenir.",
  en: "<b>4.</b> <b>idBForge BV</b> will maintain regular contact with entrepreneurs who contribute new ideas with a view to optimizing the websites. The intention is to prove optimal cooperation after the first year and to confirm this for the future.",
  de: "<b>4.</b> <b>idBForge BV</b> wird regelmäßig Kontakt mit Unternehmern pflegen, die neue Ideen einbringen, um die Websites zu optimieren. Ziel ist es, nach dem ersten Jahr eine optimale Zusammenarbeit nachzuweisen und diese für die Zukunft zu bestätigen."
}), _defineProperty(_CustomerInfo, "identityBuilding_bv_does_not_charge_any_extra_costs_for_the_services", {
  nl: "<b>5.</b> idBForge BV brengt voor de diensten die werden besproken en die deel uitmaken van deze overeenkomst geen extra kosten in rekening! Elke ondernemer heeft het recht op 1 individuele aanpassing per maand zonder meerprijs!",
  fr: "<b>5.</b> idBForge SRL ne facture pas de frais supplémentaires pour les services qui ont été discutés et qui font partie de cet accord ! Chaque entrepreneur a droit à une personnalisation individuelle par mois sans frais supplémentaires !",
  en: "<b>5.</b> <b>idBForge BV</b> does not charge any extra costs for the services that were discussed and that are part of this agreement! Every entrepreneur has the right to 1 individual adjustment per month at no additional cost!",
  de: "<b>5.</b> <b>idBForge BV</b> erhebt keine zusätzlichen Kosten für die besprochenen Dienstleistungen, die Teil dieser Vereinbarung sind! Jeder Unternehmer hat das Recht auf eine individuelle Anpassung pro Monat ohne zusätzliche Kosten!"
}), _defineProperty(_CustomerInfo, "initials_or_mandatory_initials_included_read_and_approved", {
  nl: "PARAAF OF HANDTEKENING VAN DE ONDERNEMER OF MANDATARIS",
  fr: 'PARAPHE OU SIGNATURE DE L’ENTREPRENEUR OU DE SON MANDATAIRE',
  en: "INITIALES OR MANDATORY INITIALS included read and approved",
  de: "INITIALES ODER MANDATORY INITIALS eingeschlossen, lesen und genehmigen"
}), _defineProperty(_CustomerInfo, "seven_days_after_receipt_of_invoice", {
  nl: "7 dagen na ontvangst factuur",
  fr: '7 jours après réception de la facture',
  en: "7 days after receipt of invoice",
  de: "7 Tage nach Empfang der Rechnung"
}), _defineProperty(_CustomerInfo, "fourteen_days_after_receipt_of_invoice", {
  nl: "14 dagen na ontvangst factuur",
  fr: '14 jours après réception de la facture',
  en: "14 days after receipt of invoice",
  de: "14 Tage nach Empfang der Rechnung"
}), _defineProperty(_CustomerInfo, "twentyone_days_after_receipt_of_invoice", {
  nl: "21 dagen na ontvangst factuur",
  fr: '21 jours après réception de la facture',
  en: "21 days after receipt of invoice",
  de: "21 Tage nach Empfang der Rechnung"
}), _defineProperty(_CustomerInfo, "thirty_days_after_receipt_of_invoice", {
  nl: "30 dagen na ontvangst factuur",
  fr: '30 jours après réception de la facture',
  en: "30 days after receipt of invoice",
  de: "30 Tage nach Empfang der Rechnung"
}), _defineProperty(_CustomerInfo, "thirty_days_end_of_month", {
  nl: "30 dagen einde maand",
  fr: '30 jours fin de mois',
  en: "30 days end of month",
  de: "30 Tage am Ende des Monats"
}), _defineProperty(_CustomerInfo, "in_2_payments", {
  nl: "In 2 keer (1ste betaling 7 dagen na ontvangst factuur - BTW volledig te betalen)",
  fr: 'En 2 fois (1er paiement 7 jours après réception de la facture - TVA à régler en totalité)',
  en: "In 2 payments (1st payment 7 days after receipt of invoice - VAT to be paid in full)",
  de: "In 2 Zahlungen (1. Zahlung 7 Tage nach Empfang der Rechnung - UStG zu zahlen)"
}), _defineProperty(_CustomerInfo, "in_4_payments", {
  nl: "In 4 keer (1ste betaling 7 dagen na ontvangst factuur - BTW volledig te betalen)",
  fr: 'En 4 fois (1er paiement 7 jours après réception de la facture - TVA à régler en totalité)',
  en: "In 4 payments (1st payment 7 days after receipt of invoice - VAT to be paid in full)",
  de: "In 4 Zahlungen (1. Zahlung 7 Tage nach Empfang der Rechnung - UStG zu zahlen)"
}), _defineProperty(_CustomerInfo, "in_12_payments", {
  nl: "In 12 keer (1ste betaling 7 dagen na ontvangst factuur - BTW volledig te betalen)",
  fr: 'En 12 fois (1er paiement 7 jours après réception de la facture - TVA à régler en totalité)',
  en: "In 12 payments (1st payment 7 days after receipt of invoice - VAT to be paid in full)",
  de: "In 12 Zahlungen (1. Zahlung 7 Tage nach Empfang der Rechnung - UStG zu zahlen)"
}), _defineProperty(_CustomerInfo, "save", {
  nl: "Opslaan",
  fr: "Sauvegarder",
  en: "Save",
  de: "Speichern"
}), _defineProperty(_CustomerInfo, "ci_save_your_work", {
  nl: "Bewaar jouw werk",
  fr: "Sauvegardez votre travail",
  en: "Save your work",
  de: "Speichern Sie Ihre Arbeit"
}), _defineProperty(_CustomerInfo, "new", {
  nl: "Nieuw",
  fr: "Nouveau",
  en: "New",
  de: "Neu"
}), _CustomerInfo);
var _default = CustomerInfo;
exports["default"] = _default;